/*
 * 本文件由 `npm run gen:mavlink` 生成，请勿手工编辑。
 *
 * 上游定义快照见 packages/mavlink/definitions/（含固定提交 SHA）。
 * 共 222 个枚举。跨文件扩展的枚举（如 MAV_CMD）已合并去重。
 */

import type { EnumDefinition } from '../types';

export const ENUMS: readonly EnumDefinition[] = [
  {
    name: "ACCELCAL_VEHICLE_POS",
    isBitmask: false,
    entries: [
      { name: "ACCELCAL_VEHICLE_POS_LEVEL", value: 1 },
      { name: "ACCELCAL_VEHICLE_POS_LEFT", value: 2 },
      { name: "ACCELCAL_VEHICLE_POS_RIGHT", value: 3 },
      { name: "ACCELCAL_VEHICLE_POS_NOSEDOWN", value: 4 },
      { name: "ACCELCAL_VEHICLE_POS_NOSEUP", value: 5 },
      { name: "ACCELCAL_VEHICLE_POS_BACK", value: 6 },
      { name: "ACCELCAL_VEHICLE_POS_SUCCESS", value: 16777215 },
      { name: "ACCELCAL_VEHICLE_POS_FAILED", value: 16777216 },
    ],
  },
  {
    name: "ACTUATOR_CONFIGURATION",
    isBitmask: false,
    entries: [
      { name: "ACTUATOR_CONFIGURATION_NONE", value: 0 },
      { name: "ACTUATOR_CONFIGURATION_BEEP", value: 1 },
      { name: "ACTUATOR_CONFIGURATION_3D_MODE_ON", value: 2 },
      { name: "ACTUATOR_CONFIGURATION_3D_MODE_OFF", value: 3 },
      { name: "ACTUATOR_CONFIGURATION_SPIN_DIRECTION1", value: 4 },
      { name: "ACTUATOR_CONFIGURATION_SPIN_DIRECTION2", value: 5 },
    ],
  },
  {
    name: "ACTUATOR_OUTPUT_FUNCTION",
    isBitmask: false,
    entries: [
      { name: "ACTUATOR_OUTPUT_FUNCTION_NONE", value: 0 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR1", value: 1 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR2", value: 2 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR3", value: 3 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR4", value: 4 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR5", value: 5 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR6", value: 6 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR7", value: 7 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR8", value: 8 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR9", value: 9 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR10", value: 10 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR11", value: 11 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR12", value: 12 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR13", value: 13 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR14", value: 14 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR15", value: 15 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_MOTOR16", value: 16 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO1", value: 33 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO2", value: 34 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO3", value: 35 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO4", value: 36 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO5", value: 37 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO6", value: 38 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO7", value: 39 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO8", value: 40 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO9", value: 41 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO10", value: 42 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO11", value: 43 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO12", value: 44 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO13", value: 45 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO14", value: 46 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO15", value: 47 },
      { name: "ACTUATOR_OUTPUT_FUNCTION_SERVO16", value: 48 },
    ],
  },
  {
    name: "ADSB_ALTITUDE_TYPE",
    isBitmask: false,
    entries: [
      { name: "ADSB_ALTITUDE_TYPE_PRESSURE_QNH", value: 0 },
      { name: "ADSB_ALTITUDE_TYPE_GEOMETRIC", value: 1 },
    ],
  },
  {
    name: "ADSB_EMITTER_TYPE",
    isBitmask: false,
    entries: [
      { name: "ADSB_EMITTER_TYPE_NO_INFO", value: 0 },
      { name: "ADSB_EMITTER_TYPE_LIGHT", value: 1 },
      { name: "ADSB_EMITTER_TYPE_SMALL", value: 2 },
      { name: "ADSB_EMITTER_TYPE_LARGE", value: 3 },
      { name: "ADSB_EMITTER_TYPE_HIGH_VORTEX_LARGE", value: 4 },
      { name: "ADSB_EMITTER_TYPE_HEAVY", value: 5 },
      { name: "ADSB_EMITTER_TYPE_HIGHLY_MANUV", value: 6 },
      { name: "ADSB_EMITTER_TYPE_ROTOCRAFT", value: 7 },
      { name: "ADSB_EMITTER_TYPE_UNASSIGNED", value: 8 },
      { name: "ADSB_EMITTER_TYPE_GLIDER", value: 9 },
      { name: "ADSB_EMITTER_TYPE_LIGHTER_AIR", value: 10 },
      { name: "ADSB_EMITTER_TYPE_PARACHUTE", value: 11 },
      { name: "ADSB_EMITTER_TYPE_ULTRA_LIGHT", value: 12 },
      { name: "ADSB_EMITTER_TYPE_UNASSIGNED2", value: 13 },
      { name: "ADSB_EMITTER_TYPE_UAV", value: 14 },
      { name: "ADSB_EMITTER_TYPE_SPACE", value: 15 },
      { name: "ADSB_EMITTER_TYPE_UNASSGINED3", value: 16 },
      { name: "ADSB_EMITTER_TYPE_EMERGENCY_SURFACE", value: 17 },
      { name: "ADSB_EMITTER_TYPE_SERVICE_SURFACE", value: 18 },
      { name: "ADSB_EMITTER_TYPE_POINT_OBSTACLE", value: 19 },
    ],
  },
  {
    name: "ADSB_FLAGS",
    isBitmask: true,
    entries: [
      { name: "ADSB_FLAGS_VALID_COORDS", value: 1 },
      { name: "ADSB_FLAGS_VALID_ALTITUDE", value: 2 },
      { name: "ADSB_FLAGS_VALID_HEADING", value: 4 },
      { name: "ADSB_FLAGS_VALID_VELOCITY", value: 8 },
      { name: "ADSB_FLAGS_VALID_CALLSIGN", value: 16 },
      { name: "ADSB_FLAGS_VALID_SQUAWK", value: 32 },
      { name: "ADSB_FLAGS_SIMULATED", value: 64 },
      { name: "ADSB_FLAGS_VERTICAL_VELOCITY_VALID", value: 128 },
      { name: "ADSB_FLAGS_BARO_VALID", value: 256 },
      { name: "ADSB_FLAGS_SOURCE_UAT", value: 32768 },
    ],
  },
  {
    name: "AIRLINK_AUTH_RESPONSE_TYPE",
    isBitmask: false,
    entries: [
      { name: "AIRLINK_ERROR_LOGIN_OR_PASS", value: 0 },
      { name: "AIRLINK_AUTH_OK", value: 1 },
    ],
  },
  {
    name: "AIRSPEED_SENSOR_FLAGS",
    isBitmask: true,
    entries: [
      { name: "AIRSPEED_SENSOR_UNHEALTHY", value: 1 },
      { name: "AIRSPEED_SENSOR_USING", value: 2 },
    ],
  },
  {
    name: "AIS_FLAGS",
    isBitmask: true,
    entries: [
      { name: "AIS_FLAGS_POSITION_ACCURACY", value: 1 },
      { name: "AIS_FLAGS_VALID_COG", value: 2 },
      { name: "AIS_FLAGS_VALID_VELOCITY", value: 4 },
      { name: "AIS_FLAGS_HIGH_VELOCITY", value: 8 },
      { name: "AIS_FLAGS_VALID_TURN_RATE", value: 16 },
      { name: "AIS_FLAGS_TURN_RATE_SIGN_ONLY", value: 32 },
      { name: "AIS_FLAGS_VALID_DIMENSIONS", value: 64 },
      { name: "AIS_FLAGS_LARGE_BOW_DIMENSION", value: 128 },
      { name: "AIS_FLAGS_LARGE_STERN_DIMENSION", value: 256 },
      { name: "AIS_FLAGS_LARGE_PORT_DIMENSION", value: 512 },
      { name: "AIS_FLAGS_LARGE_STARBOARD_DIMENSION", value: 1024 },
      { name: "AIS_FLAGS_VALID_CALLSIGN", value: 2048 },
      { name: "AIS_FLAGS_VALID_NAME", value: 4096 },
    ],
  },
  {
    name: "AIS_NAV_STATUS",
    isBitmask: false,
    entries: [
      { name: "AIS_NAV_STATUS_UNDER_WAY", value: 0 },
      { name: "AIS_NAV_STATUS_ANCHORED", value: 1 },
      { name: "AIS_NAV_STATUS_UN_COMMANDED", value: 2 },
      { name: "AIS_NAV_STATUS_RESTRICTED_MANOEUVERABILITY", value: 3 },
      { name: "AIS_NAV_STATUS_DRAUGHT_CONSTRAINED", value: 4 },
      { name: "AIS_NAV_STATUS_MOORED", value: 5 },
      { name: "AIS_NAV_STATUS_AGROUND", value: 6 },
      { name: "AIS_NAV_STATUS_FISHING", value: 7 },
      { name: "AIS_NAV_STATUS_SAILING", value: 8 },
      { name: "AIS_NAV_STATUS_RESERVED_HSC", value: 9 },
      { name: "AIS_NAV_STATUS_RESERVED_WIG", value: 10 },
      { name: "AIS_NAV_STATUS_RESERVED_1", value: 11 },
      { name: "AIS_NAV_STATUS_RESERVED_2", value: 12 },
      { name: "AIS_NAV_STATUS_RESERVED_3", value: 13 },
      { name: "AIS_NAV_STATUS_AIS_SART", value: 14 },
      { name: "AIS_NAV_STATUS_UNKNOWN", value: 15 },
    ],
  },
  {
    name: "AIS_TYPE",
    isBitmask: false,
    entries: [
      { name: "AIS_TYPE_UNKNOWN", value: 0 },
      { name: "AIS_TYPE_RESERVED_1", value: 1 },
      { name: "AIS_TYPE_RESERVED_2", value: 2 },
      { name: "AIS_TYPE_RESERVED_3", value: 3 },
      { name: "AIS_TYPE_RESERVED_4", value: 4 },
      { name: "AIS_TYPE_RESERVED_5", value: 5 },
      { name: "AIS_TYPE_RESERVED_6", value: 6 },
      { name: "AIS_TYPE_RESERVED_7", value: 7 },
      { name: "AIS_TYPE_RESERVED_8", value: 8 },
      { name: "AIS_TYPE_RESERVED_9", value: 9 },
      { name: "AIS_TYPE_RESERVED_10", value: 10 },
      { name: "AIS_TYPE_RESERVED_11", value: 11 },
      { name: "AIS_TYPE_RESERVED_12", value: 12 },
      { name: "AIS_TYPE_RESERVED_13", value: 13 },
      { name: "AIS_TYPE_RESERVED_14", value: 14 },
      { name: "AIS_TYPE_RESERVED_15", value: 15 },
      { name: "AIS_TYPE_RESERVED_16", value: 16 },
      { name: "AIS_TYPE_RESERVED_17", value: 17 },
      { name: "AIS_TYPE_RESERVED_18", value: 18 },
      { name: "AIS_TYPE_RESERVED_19", value: 19 },
      { name: "AIS_TYPE_WIG", value: 20 },
      { name: "AIS_TYPE_WIG_HAZARDOUS_A", value: 21 },
      { name: "AIS_TYPE_WIG_HAZARDOUS_B", value: 22 },
      { name: "AIS_TYPE_WIG_HAZARDOUS_C", value: 23 },
      { name: "AIS_TYPE_WIG_HAZARDOUS_D", value: 24 },
      { name: "AIS_TYPE_WIG_RESERVED_1", value: 25 },
      { name: "AIS_TYPE_WIG_RESERVED_2", value: 26 },
      { name: "AIS_TYPE_WIG_RESERVED_3", value: 27 },
      { name: "AIS_TYPE_WIG_RESERVED_4", value: 28 },
      { name: "AIS_TYPE_WIG_RESERVED_5", value: 29 },
      { name: "AIS_TYPE_FISHING", value: 30 },
      { name: "AIS_TYPE_TOWING", value: 31 },
      { name: "AIS_TYPE_TOWING_LARGE", value: 32 },
      { name: "AIS_TYPE_DREDGING", value: 33 },
      { name: "AIS_TYPE_DIVING", value: 34 },
      { name: "AIS_TYPE_MILITARY", value: 35 },
      { name: "AIS_TYPE_SAILING", value: 36 },
      { name: "AIS_TYPE_PLEASURE", value: 37 },
      { name: "AIS_TYPE_RESERVED_20", value: 38 },
      { name: "AIS_TYPE_RESERVED_21", value: 39 },
      { name: "AIS_TYPE_HSC", value: 40 },
      { name: "AIS_TYPE_HSC_HAZARDOUS_A", value: 41 },
      { name: "AIS_TYPE_HSC_HAZARDOUS_B", value: 42 },
      { name: "AIS_TYPE_HSC_HAZARDOUS_C", value: 43 },
      { name: "AIS_TYPE_HSC_HAZARDOUS_D", value: 44 },
      { name: "AIS_TYPE_HSC_RESERVED_1", value: 45 },
      { name: "AIS_TYPE_HSC_RESERVED_2", value: 46 },
      { name: "AIS_TYPE_HSC_RESERVED_3", value: 47 },
      { name: "AIS_TYPE_HSC_RESERVED_4", value: 48 },
      { name: "AIS_TYPE_HSC_UNKNOWN", value: 49 },
      { name: "AIS_TYPE_PILOT", value: 50 },
      { name: "AIS_TYPE_SAR", value: 51 },
      { name: "AIS_TYPE_TUG", value: 52 },
      { name: "AIS_TYPE_PORT_TENDER", value: 53 },
      { name: "AIS_TYPE_ANTI_POLLUTION", value: 54 },
      { name: "AIS_TYPE_LAW_ENFORCEMENT", value: 55 },
      { name: "AIS_TYPE_SPARE_LOCAL_1", value: 56 },
      { name: "AIS_TYPE_SPARE_LOCAL_2", value: 57 },
      { name: "AIS_TYPE_MEDICAL_TRANSPORT", value: 58 },
      { name: "AIS_TYPE_NONECOMBATANT", value: 59 },
      { name: "AIS_TYPE_PASSENGER", value: 60 },
      { name: "AIS_TYPE_PASSENGER_HAZARDOUS_A", value: 61 },
      { name: "AIS_TYPE_PASSENGER_HAZARDOUS_B", value: 62 },
      { name: "AIS_TYPE_PASSENGER_HAZARDOUS_C", value: 63 },
      { name: "AIS_TYPE_PASSENGER_HAZARDOUS_D", value: 64 },
      { name: "AIS_TYPE_PASSENGER_RESERVED_1", value: 65 },
      { name: "AIS_TYPE_PASSENGER_RESERVED_2", value: 66 },
      { name: "AIS_TYPE_PASSENGER_RESERVED_3", value: 67 },
      { name: "AIS_TYPE_PASSENGER_RESERVED_4", value: 68 },
      { name: "AIS_TYPE_PASSENGER_UNKNOWN", value: 69 },
      { name: "AIS_TYPE_CARGO", value: 70 },
      { name: "AIS_TYPE_CARGO_HAZARDOUS_A", value: 71 },
      { name: "AIS_TYPE_CARGO_HAZARDOUS_B", value: 72 },
      { name: "AIS_TYPE_CARGO_HAZARDOUS_C", value: 73 },
      { name: "AIS_TYPE_CARGO_HAZARDOUS_D", value: 74 },
      { name: "AIS_TYPE_CARGO_RESERVED_1", value: 75 },
      { name: "AIS_TYPE_CARGO_RESERVED_2", value: 76 },
      { name: "AIS_TYPE_CARGO_RESERVED_3", value: 77 },
      { name: "AIS_TYPE_CARGO_RESERVED_4", value: 78 },
      { name: "AIS_TYPE_CARGO_UNKNOWN", value: 79 },
      { name: "AIS_TYPE_TANKER", value: 80 },
      { name: "AIS_TYPE_TANKER_HAZARDOUS_A", value: 81 },
      { name: "AIS_TYPE_TANKER_HAZARDOUS_B", value: 82 },
      { name: "AIS_TYPE_TANKER_HAZARDOUS_C", value: 83 },
      { name: "AIS_TYPE_TANKER_HAZARDOUS_D", value: 84 },
      { name: "AIS_TYPE_TANKER_RESERVED_1", value: 85 },
      { name: "AIS_TYPE_TANKER_RESERVED_2", value: 86 },
      { name: "AIS_TYPE_TANKER_RESERVED_3", value: 87 },
      { name: "AIS_TYPE_TANKER_RESERVED_4", value: 88 },
      { name: "AIS_TYPE_TANKER_UNKNOWN", value: 89 },
      { name: "AIS_TYPE_OTHER", value: 90 },
      { name: "AIS_TYPE_OTHER_HAZARDOUS_A", value: 91 },
      { name: "AIS_TYPE_OTHER_HAZARDOUS_B", value: 92 },
      { name: "AIS_TYPE_OTHER_HAZARDOUS_C", value: 93 },
      { name: "AIS_TYPE_OTHER_HAZARDOUS_D", value: 94 },
      { name: "AIS_TYPE_OTHER_RESERVED_1", value: 95 },
      { name: "AIS_TYPE_OTHER_RESERVED_2", value: 96 },
      { name: "AIS_TYPE_OTHER_RESERVED_3", value: 97 },
      { name: "AIS_TYPE_OTHER_RESERVED_4", value: 98 },
      { name: "AIS_TYPE_OTHER_UNKNOWN", value: 99 },
    ],
  },
  {
    name: "ATTITUDE_TARGET_TYPEMASK",
    isBitmask: true,
    entries: [
      { name: "ATTITUDE_TARGET_TYPEMASK_BODY_ROLL_RATE_IGNORE", value: 1 },
      { name: "ATTITUDE_TARGET_TYPEMASK_BODY_PITCH_RATE_IGNORE", value: 2 },
      { name: "ATTITUDE_TARGET_TYPEMASK_BODY_YAW_RATE_IGNORE", value: 4 },
      { name: "ATTITUDE_TARGET_TYPEMASK_THRUST_BODY_SET", value: 32 },
      { name: "ATTITUDE_TARGET_TYPEMASK_THROTTLE_IGNORE", value: 64 },
      { name: "ATTITUDE_TARGET_TYPEMASK_ATTITUDE_IGNORE", value: 128 },
    ],
  },
  {
    name: "AUTOTUNE_AXIS",
    isBitmask: true,
    entries: [
      { name: "AUTOTUNE_AXIS_ROLL", value: 1 },
      { name: "AUTOTUNE_AXIS_PITCH", value: 2 },
      { name: "AUTOTUNE_AXIS_YAW", value: 4 },
    ],
  },
  {
    name: "CAMERA_CAP_FLAGS",
    isBitmask: true,
    entries: [
      { name: "CAMERA_CAP_FLAGS_CAPTURE_VIDEO", value: 1 },
      { name: "CAMERA_CAP_FLAGS_CAPTURE_IMAGE", value: 2 },
      { name: "CAMERA_CAP_FLAGS_HAS_MODES", value: 4 },
      { name: "CAMERA_CAP_FLAGS_CAN_CAPTURE_IMAGE_IN_VIDEO_MODE", value: 8 },
      { name: "CAMERA_CAP_FLAGS_CAN_CAPTURE_VIDEO_IN_IMAGE_MODE", value: 16 },
      { name: "CAMERA_CAP_FLAGS_HAS_IMAGE_SURVEY_MODE", value: 32 },
      { name: "CAMERA_CAP_FLAGS_HAS_BASIC_ZOOM", value: 64 },
      { name: "CAMERA_CAP_FLAGS_HAS_BASIC_FOCUS", value: 128 },
      { name: "CAMERA_CAP_FLAGS_HAS_VIDEO_STREAM", value: 256 },
      { name: "CAMERA_CAP_FLAGS_HAS_TRACKING_POINT", value: 512 },
      { name: "CAMERA_CAP_FLAGS_HAS_TRACKING_RECTANGLE", value: 1024 },
      { name: "CAMERA_CAP_FLAGS_HAS_TRACKING_GEO_STATUS", value: 2048 },
      { name: "CAMERA_CAP_FLAGS_HAS_THERMAL_RANGE", value: 4096 },
      { name: "CAMERA_CAP_FLAGS_HAS_MTI", value: 8192 },
    ],
  },
  {
    name: "CAMERA_FEEDBACK_FLAGS",
    isBitmask: false,
    entries: [
      { name: "CAMERA_FEEDBACK_PHOTO", value: 0 },
      { name: "CAMERA_FEEDBACK_VIDEO", value: 1 },
      { name: "CAMERA_FEEDBACK_BADEXPOSURE", value: 2 },
      { name: "CAMERA_FEEDBACK_CLOSEDLOOP", value: 3 },
      { name: "CAMERA_FEEDBACK_OPENLOOP", value: 4 },
    ],
  },
  {
    name: "CAMERA_MODE",
    isBitmask: false,
    entries: [
      { name: "CAMERA_MODE_IMAGE", value: 0 },
      { name: "CAMERA_MODE_VIDEO", value: 1 },
      { name: "CAMERA_MODE_IMAGE_SURVEY", value: 2 },
    ],
  },
  {
    name: "CAMERA_SOURCE",
    isBitmask: false,
    entries: [
      { name: "CAMERA_SOURCE_DEFAULT", value: 0 },
      { name: "CAMERA_SOURCE_RGB", value: 1 },
      { name: "CAMERA_SOURCE_IR", value: 2 },
      { name: "CAMERA_SOURCE_NDVI", value: 3 },
    ],
  },
  {
    name: "CAMERA_STATUS_TYPES",
    isBitmask: false,
    entries: [
      { name: "CAMERA_STATUS_TYPE_HEARTBEAT", value: 0 },
      { name: "CAMERA_STATUS_TYPE_TRIGGER", value: 1 },
      { name: "CAMERA_STATUS_TYPE_DISCONNECT", value: 2 },
      { name: "CAMERA_STATUS_TYPE_ERROR", value: 3 },
      { name: "CAMERA_STATUS_TYPE_LOWBATT", value: 4 },
      { name: "CAMERA_STATUS_TYPE_LOWSTORE", value: 5 },
      { name: "CAMERA_STATUS_TYPE_LOWSTOREV", value: 6 },
    ],
  },
  {
    name: "CAMERA_TRACKING_MODE",
    isBitmask: false,
    entries: [
      { name: "CAMERA_TRACKING_MODE_NONE", value: 0 },
      { name: "CAMERA_TRACKING_MODE_POINT", value: 1 },
      { name: "CAMERA_TRACKING_MODE_RECTANGLE", value: 2 },
    ],
  },
  {
    name: "CAMERA_TRACKING_STATUS_FLAGS",
    isBitmask: true,
    entries: [
      { name: "CAMERA_TRACKING_STATUS_FLAGS_IDLE", value: 0 },
      { name: "CAMERA_TRACKING_STATUS_FLAGS_ACTIVE", value: 1 },
      { name: "CAMERA_TRACKING_STATUS_FLAGS_ERROR", value: 2 },
      { name: "CAMERA_TRACKING_STATUS_FLAGS_MTI", value: 4 },
      { name: "CAMERA_TRACKING_STATUS_FLAGS_COASTING", value: 8 },
    ],
  },
  {
    name: "CAMERA_TRACKING_TARGET_DATA",
    isBitmask: true,
    entries: [
      { name: "CAMERA_TRACKING_TARGET_DATA_EMBEDDED", value: 1 },
      { name: "CAMERA_TRACKING_TARGET_DATA_RENDERED", value: 2 },
      { name: "CAMERA_TRACKING_TARGET_DATA_IN_STATUS", value: 4 },
    ],
  },
  {
    name: "CAMERA_ZOOM_TYPE",
    isBitmask: false,
    entries: [
      { name: "ZOOM_TYPE_STEP", value: 0 },
      { name: "ZOOM_TYPE_CONTINUOUS", value: 1 },
      { name: "ZOOM_TYPE_RANGE", value: 2 },
      { name: "ZOOM_TYPE_FOCAL_LENGTH", value: 3 },
      { name: "ZOOM_TYPE_HORIZONTAL_FOV", value: 4 },
    ],
  },
  {
    name: "CAN_FILTER_OP",
    isBitmask: false,
    entries: [
      { name: "CAN_FILTER_REPLACE", value: 0 },
      { name: "CAN_FILTER_ADD", value: 1 },
      { name: "CAN_FILTER_REMOVE", value: 2 },
    ],
  },
  {
    name: "CELLULAR_CONFIG_RESPONSE",
    isBitmask: false,
    entries: [
      { name: "CELLULAR_CONFIG_RESPONSE_ACCEPTED", value: 0 },
      { name: "CELLULAR_CONFIG_RESPONSE_APN_ERROR", value: 1 },
      { name: "CELLULAR_CONFIG_RESPONSE_PIN_ERROR", value: 2 },
      { name: "CELLULAR_CONFIG_RESPONSE_REJECTED", value: 3 },
      { name: "CELLULAR_CONFIG_BLOCKED_PUK_REQUIRED", value: 4 },
    ],
  },
  {
    name: "CELLULAR_NETWORK_FAILED_REASON",
    isBitmask: false,
    entries: [
      { name: "CELLULAR_NETWORK_FAILED_REASON_NONE", value: 0 },
      { name: "CELLULAR_NETWORK_FAILED_REASON_UNKNOWN", value: 1 },
      { name: "CELLULAR_NETWORK_FAILED_REASON_SIM_MISSING", value: 2 },
      { name: "CELLULAR_NETWORK_FAILED_REASON_SIM_ERROR", value: 3 },
    ],
  },
  {
    name: "CELLULAR_NETWORK_RADIO_TYPE",
    isBitmask: false,
    entries: [
      { name: "CELLULAR_NETWORK_RADIO_TYPE_NONE", value: 0 },
      { name: "CELLULAR_NETWORK_RADIO_TYPE_GSM", value: 1 },
      { name: "CELLULAR_NETWORK_RADIO_TYPE_CDMA", value: 2 },
      { name: "CELLULAR_NETWORK_RADIO_TYPE_WCDMA", value: 3 },
      { name: "CELLULAR_NETWORK_RADIO_TYPE_LTE", value: 4 },
    ],
  },
  {
    name: "CELLULAR_STATUS_FLAG",
    isBitmask: false,
    entries: [
      { name: "CELLULAR_STATUS_FLAG_UNKNOWN", value: 0 },
      { name: "CELLULAR_STATUS_FLAG_FAILED", value: 1 },
      { name: "CELLULAR_STATUS_FLAG_INITIALIZING", value: 2 },
      { name: "CELLULAR_STATUS_FLAG_LOCKED", value: 3 },
      { name: "CELLULAR_STATUS_FLAG_DISABLED", value: 4 },
      { name: "CELLULAR_STATUS_FLAG_DISABLING", value: 5 },
      { name: "CELLULAR_STATUS_FLAG_ENABLING", value: 6 },
      { name: "CELLULAR_STATUS_FLAG_ENABLED", value: 7 },
      { name: "CELLULAR_STATUS_FLAG_SEARCHING", value: 8 },
      { name: "CELLULAR_STATUS_FLAG_REGISTERED", value: 9 },
      { name: "CELLULAR_STATUS_FLAG_DISCONNECTING", value: 10 },
      { name: "CELLULAR_STATUS_FLAG_CONNECTING", value: 11 },
      { name: "CELLULAR_STATUS_FLAG_CONNECTED", value: 12 },
    ],
  },
  {
    name: "COMP_METADATA_TYPE",
    isBitmask: false,
    entries: [
      { name: "COMP_METADATA_TYPE_GENERAL", value: 0 },
      { name: "COMP_METADATA_TYPE_PARAMETER", value: 1 },
      { name: "COMP_METADATA_TYPE_COMMANDS", value: 2 },
      { name: "COMP_METADATA_TYPE_PERIPHERALS", value: 3 },
      { name: "COMP_METADATA_TYPE_EVENTS", value: 4 },
      { name: "COMP_METADATA_TYPE_ACTUATORS", value: 5 },
    ],
  },
  {
    name: "COMPUTER_STATUS_FLAGS",
    isBitmask: true,
    entries: [
      { name: "COMPUTER_STATUS_FLAGS_UNDER_VOLTAGE", value: 1 },
      { name: "COMPUTER_STATUS_FLAGS_CPU_THROTTLE", value: 2 },
      { name: "COMPUTER_STATUS_FLAGS_THERMAL_THROTTLE", value: 4 },
      { name: "COMPUTER_STATUS_FLAGS_DISK_FULL", value: 8 },
    ],
  },
  {
    name: "COPTER_MODE",
    isBitmask: false,
    entries: [
      { name: "COPTER_MODE_STABILIZE", value: 0 },
      { name: "COPTER_MODE_ACRO", value: 1 },
      { name: "COPTER_MODE_ALT_HOLD", value: 2 },
      { name: "COPTER_MODE_AUTO", value: 3 },
      { name: "COPTER_MODE_GUIDED", value: 4 },
      { name: "COPTER_MODE_LOITER", value: 5 },
      { name: "COPTER_MODE_RTL", value: 6 },
      { name: "COPTER_MODE_CIRCLE", value: 7 },
      { name: "COPTER_MODE_LAND", value: 9 },
      { name: "COPTER_MODE_DRIFT", value: 11 },
      { name: "COPTER_MODE_SPORT", value: 13 },
      { name: "COPTER_MODE_FLIP", value: 14 },
      { name: "COPTER_MODE_AUTOTUNE", value: 15 },
      { name: "COPTER_MODE_POSHOLD", value: 16 },
      { name: "COPTER_MODE_BRAKE", value: 17 },
      { name: "COPTER_MODE_THROW", value: 18 },
      { name: "COPTER_MODE_AVOID_ADSB", value: 19 },
      { name: "COPTER_MODE_GUIDED_NOGPS", value: 20 },
      { name: "COPTER_MODE_SMART_RTL", value: 21 },
      { name: "COPTER_MODE_FLOWHOLD", value: 22 },
      { name: "COPTER_MODE_FOLLOW", value: 23 },
      { name: "COPTER_MODE_ZIGZAG", value: 24 },
      { name: "COPTER_MODE_SYSTEMID", value: 25 },
      { name: "COPTER_MODE_AUTOROTATE", value: 26 },
      { name: "COPTER_MODE_AUTO_RTL", value: 27 },
      { name: "COPTER_MODE_TURTLE", value: 28 },
    ],
  },
  {
    name: "DEEPSTALL_STAGE",
    isBitmask: false,
    entries: [
      { name: "DEEPSTALL_STAGE_FLY_TO_LANDING", value: 0 },
      { name: "DEEPSTALL_STAGE_ESTIMATE_WIND", value: 1 },
      { name: "DEEPSTALL_STAGE_WAIT_FOR_BREAKOUT", value: 2 },
      { name: "DEEPSTALL_STAGE_FLY_TO_ARC", value: 3 },
      { name: "DEEPSTALL_STAGE_ARC", value: 4 },
      { name: "DEEPSTALL_STAGE_APPROACH", value: 5 },
      { name: "DEEPSTALL_STAGE_LAND", value: 6 },
    ],
  },
  {
    name: "DEVICE_OP_BUSTYPE",
    isBitmask: false,
    entries: [
      { name: "DEVICE_OP_BUSTYPE_I2C", value: 0 },
      { name: "DEVICE_OP_BUSTYPE_SPI", value: 1 },
    ],
  },
  {
    name: "EKF_STATUS_FLAGS",
    isBitmask: true,
    entries: [
      { name: "EKF_ATTITUDE", value: 1 },
      { name: "EKF_VELOCITY_HORIZ", value: 2 },
      { name: "EKF_VELOCITY_VERT", value: 4 },
      { name: "EKF_POS_HORIZ_REL", value: 8 },
      { name: "EKF_POS_HORIZ_ABS", value: 16 },
      { name: "EKF_POS_VERT_ABS", value: 32 },
      { name: "EKF_POS_VERT_AGL", value: 64 },
      { name: "EKF_CONST_POS_MODE", value: 128 },
      { name: "EKF_PRED_POS_HORIZ_REL", value: 256 },
      { name: "EKF_PRED_POS_HORIZ_ABS", value: 512 },
      { name: "EKF_UNINITIALIZED", value: 1024 },
      { name: "EKF_GPS_GLITCHING", value: 32768 },
    ],
  },
  {
    name: "ENGINE_CONTROL_OPTIONS",
    isBitmask: true,
    entries: [
      { name: "ENGINE_CONTROL_OPTIONS_ALLOW_START_WHILE_DISARMED", value: 1 },
    ],
  },
  {
    name: "ESC_CONNECTION_TYPE",
    isBitmask: false,
    entries: [
      { name: "ESC_CONNECTION_TYPE_PPM", value: 0 },
      { name: "ESC_CONNECTION_TYPE_SERIAL", value: 1 },
      { name: "ESC_CONNECTION_TYPE_ONESHOT", value: 2 },
      { name: "ESC_CONNECTION_TYPE_I2C", value: 3 },
      { name: "ESC_CONNECTION_TYPE_CAN", value: 4 },
      { name: "ESC_CONNECTION_TYPE_DSHOT", value: 5 },
    ],
  },
  {
    name: "ESC_FAILURE_FLAGS",
    isBitmask: true,
    entries: [
      { name: "ESC_FAILURE_OVER_CURRENT", value: 1 },
      { name: "ESC_FAILURE_OVER_VOLTAGE", value: 2 },
      { name: "ESC_FAILURE_OVER_TEMPERATURE", value: 4 },
      { name: "ESC_FAILURE_OVER_RPM", value: 8 },
      { name: "ESC_FAILURE_INCONSISTENT_CMD", value: 16 },
      { name: "ESC_FAILURE_MOTOR_STUCK", value: 32 },
      { name: "ESC_FAILURE_GENERIC", value: 64 },
    ],
  },
  {
    name: "ESTIMATOR_STATUS_FLAGS",
    isBitmask: true,
    entries: [
      { name: "ESTIMATOR_ATTITUDE", value: 1 },
      { name: "ESTIMATOR_VELOCITY_HORIZ", value: 2 },
      { name: "ESTIMATOR_VELOCITY_VERT", value: 4 },
      { name: "ESTIMATOR_POS_HORIZ_REL", value: 8 },
      { name: "ESTIMATOR_POS_HORIZ_ABS", value: 16 },
      { name: "ESTIMATOR_POS_VERT_ABS", value: 32 },
      { name: "ESTIMATOR_POS_VERT_AGL", value: 64 },
      { name: "ESTIMATOR_CONST_POS_MODE", value: 128 },
      { name: "ESTIMATOR_PRED_POS_HORIZ_REL", value: 256 },
      { name: "ESTIMATOR_PRED_POS_HORIZ_ABS", value: 512 },
      { name: "ESTIMATOR_GPS_GLITCH", value: 1024 },
      { name: "ESTIMATOR_ACCEL_ERROR", value: 2048 },
    ],
  },
  {
    name: "FAILURE_TYPE",
    isBitmask: false,
    entries: [
      { name: "FAILURE_TYPE_OK", value: 0 },
      { name: "FAILURE_TYPE_OFF", value: 1 },
      { name: "FAILURE_TYPE_STUCK", value: 2 },
      { name: "FAILURE_TYPE_GARBAGE", value: 3 },
      { name: "FAILURE_TYPE_WRONG", value: 4 },
      { name: "FAILURE_TYPE_SLOW", value: 5 },
      { name: "FAILURE_TYPE_DELAYED", value: 6 },
      { name: "FAILURE_TYPE_INTERMITTENT", value: 7 },
      { name: "FAILURE_TYPE_DRIFT", value: 8 },
    ],
  },
  {
    name: "FAILURE_UNIT",
    isBitmask: false,
    entries: [
      { name: "FAILURE_UNIT_SENSOR_GYRO", value: 0 },
      { name: "FAILURE_UNIT_SENSOR_ACCEL", value: 1 },
      { name: "FAILURE_UNIT_SENSOR_MAG", value: 2 },
      { name: "FAILURE_UNIT_SENSOR_BARO", value: 3 },
      { name: "FAILURE_UNIT_SENSOR_GPS", value: 4 },
      { name: "FAILURE_UNIT_SENSOR_OPTICAL_FLOW", value: 5 },
      { name: "FAILURE_UNIT_SENSOR_VIO", value: 6 },
      { name: "FAILURE_UNIT_SENSOR_DISTANCE_SENSOR", value: 7 },
      { name: "FAILURE_UNIT_SENSOR_AIRSPEED", value: 8 },
      { name: "FAILURE_UNIT_SYSTEM_BATTERY", value: 100 },
      { name: "FAILURE_UNIT_SYSTEM_MOTOR", value: 101 },
      { name: "FAILURE_UNIT_SYSTEM_SERVO", value: 102 },
      { name: "FAILURE_UNIT_SYSTEM_AVOIDANCE", value: 103 },
      { name: "FAILURE_UNIT_SYSTEM_RC_SIGNAL", value: 104 },
      { name: "FAILURE_UNIT_SYSTEM_MAVLINK_SIGNAL", value: 105 },
      { name: "FAILURE_UNIT_SYSTEM_ESC", value: 106 },
      { name: "FAILURE_UNIT_SYSTEM_TRAFFIC_AVOIDANCE", value: 107 },
      { name: "FAILURE_UNIT_DATALINK_LTE", value: 150 },
      { name: "FAILURE_UNIT_DATALINK_WIFI", value: 151 },
      { name: "FAILURE_UNIT_DATALINK_TELEM_RADIO", value: 152 },
      { name: "FAILURE_UNIT_BUS_CAN", value: 200 },
      { name: "FAILURE_UNIT_BUS_I2C", value: 201 },
    ],
  },
  {
    name: "FENCE_BREACH",
    isBitmask: false,
    entries: [
      { name: "FENCE_BREACH_NONE", value: 0 },
      { name: "FENCE_BREACH_MINALT", value: 1 },
      { name: "FENCE_BREACH_MAXALT", value: 2 },
      { name: "FENCE_BREACH_BOUNDARY", value: 3 },
    ],
  },
  {
    name: "FENCE_MITIGATE",
    isBitmask: false,
    entries: [
      { name: "FENCE_MITIGATE_UNKNOWN", value: 0 },
      { name: "FENCE_MITIGATE_NONE", value: 1 },
      { name: "FENCE_MITIGATE_VEL_LIMIT", value: 2 },
    ],
  },
  {
    name: "FENCE_TYPE",
    isBitmask: true,
    entries: [
      { name: "FENCE_TYPE_ALT_MAX", value: 1 },
      { name: "FENCE_TYPE_CIRCLE", value: 2 },
      { name: "FENCE_TYPE_POLYGON", value: 4 },
      { name: "FENCE_TYPE_ALT_MIN", value: 8 },
    ],
  },
  {
    name: "FIRMWARE_VERSION_TYPE",
    isBitmask: false,
    entries: [
      { name: "FIRMWARE_VERSION_TYPE_DEV", value: 0 },
      { name: "FIRMWARE_VERSION_TYPE_ALPHA", value: 64 },
      { name: "FIRMWARE_VERSION_TYPE_BETA", value: 128 },
      { name: "FIRMWARE_VERSION_TYPE_RC", value: 192 },
      { name: "FIRMWARE_VERSION_TYPE_OFFICIAL", value: 255 },
    ],
  },
  {
    name: "FOLLOW_TARGET_CAP_FLAGS",
    isBitmask: true,
    entries: [
      { name: "FOLLOW_TARGET_CAP_FLAGS_POS", value: 1 },
      { name: "FOLLOW_TARGET_CAP_FLAGS_VEL", value: 2 },
      { name: "FOLLOW_TARGET_CAP_FLAGS_ACCEL", value: 4 },
      { name: "FOLLOW_TARGET_CAP_FLAGS_ATT_RATES", value: 8 },
    ],
  },
  {
    name: "GIMBAL_AXIS",
    isBitmask: false,
    entries: [
      { name: "GIMBAL_AXIS_YAW", value: 0 },
      { name: "GIMBAL_AXIS_PITCH", value: 1 },
      { name: "GIMBAL_AXIS_ROLL", value: 2 },
    ],
  },
  {
    name: "GIMBAL_AXIS_CALIBRATION_REQUIRED",
    isBitmask: false,
    entries: [
      { name: "GIMBAL_AXIS_CALIBRATION_REQUIRED_UNKNOWN", value: 0 },
      { name: "GIMBAL_AXIS_CALIBRATION_REQUIRED_TRUE", value: 1 },
      { name: "GIMBAL_AXIS_CALIBRATION_REQUIRED_FALSE", value: 2 },
    ],
  },
  {
    name: "GIMBAL_AXIS_CALIBRATION_STATUS",
    isBitmask: false,
    entries: [
      { name: "GIMBAL_AXIS_CALIBRATION_STATUS_IN_PROGRESS", value: 0 },
      { name: "GIMBAL_AXIS_CALIBRATION_STATUS_SUCCEEDED", value: 1 },
      { name: "GIMBAL_AXIS_CALIBRATION_STATUS_FAILED", value: 2 },
    ],
  },
  {
    name: "GIMBAL_DEVICE_CAP_FLAGS",
    isBitmask: true,
    entries: [
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_RETRACT", value: 1 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_NEUTRAL", value: 2 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_AXIS", value: 4 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_FOLLOW", value: 8 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_ROLL_LOCK", value: 16 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_AXIS", value: 32 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_FOLLOW", value: 64 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_PITCH_LOCK", value: 128 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_AXIS", value: 256 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_FOLLOW", value: 512 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_YAW_LOCK", value: 1024 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_SUPPORTS_INFINITE_YAW", value: 2048 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_SUPPORTS_YAW_IN_EARTH_FRAME", value: 4096 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_HAS_RC_INPUTS", value: 8192 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_CAN_POINT_LOCATION_LOCAL", value: 65536 },
      { name: "GIMBAL_DEVICE_CAP_FLAGS_CAN_POINT_LOCATION_GLOBAL", value: 131072 },
    ],
  },
  {
    name: "GIMBAL_DEVICE_ERROR_FLAGS",
    isBitmask: true,
    entries: [
      { name: "GIMBAL_DEVICE_ERROR_FLAGS_AT_ROLL_LIMIT", value: 1 },
      { name: "GIMBAL_DEVICE_ERROR_FLAGS_AT_PITCH_LIMIT", value: 2 },
      { name: "GIMBAL_DEVICE_ERROR_FLAGS_AT_YAW_LIMIT", value: 4 },
      { name: "GIMBAL_DEVICE_ERROR_FLAGS_ENCODER_ERROR", value: 8 },
      { name: "GIMBAL_DEVICE_ERROR_FLAGS_POWER_ERROR", value: 16 },
      { name: "GIMBAL_DEVICE_ERROR_FLAGS_MOTOR_ERROR", value: 32 },
      { name: "GIMBAL_DEVICE_ERROR_FLAGS_SOFTWARE_ERROR", value: 64 },
      { name: "GIMBAL_DEVICE_ERROR_FLAGS_COMMS_ERROR", value: 128 },
      { name: "GIMBAL_DEVICE_ERROR_FLAGS_CALIBRATION_RUNNING", value: 256 },
      { name: "GIMBAL_DEVICE_ERROR_FLAGS_NO_MANAGER", value: 512 },
    ],
  },
  {
    name: "GIMBAL_DEVICE_FLAGS",
    isBitmask: true,
    entries: [
      { name: "GIMBAL_DEVICE_FLAGS_RETRACT", value: 1 },
      { name: "GIMBAL_DEVICE_FLAGS_NEUTRAL", value: 2 },
      { name: "GIMBAL_DEVICE_FLAGS_ROLL_LOCK", value: 4 },
      { name: "GIMBAL_DEVICE_FLAGS_PITCH_LOCK", value: 8 },
      { name: "GIMBAL_DEVICE_FLAGS_YAW_LOCK", value: 16 },
      { name: "GIMBAL_DEVICE_FLAGS_YAW_IN_VEHICLE_FRAME", value: 32 },
      { name: "GIMBAL_DEVICE_FLAGS_YAW_IN_EARTH_FRAME", value: 64 },
      { name: "GIMBAL_DEVICE_FLAGS_ACCEPTS_YAW_IN_EARTH_FRAME", value: 128 },
      { name: "GIMBAL_DEVICE_FLAGS_RC_EXCLUSIVE", value: 256 },
      { name: "GIMBAL_DEVICE_FLAGS_RC_MIXED", value: 512 },
    ],
  },
  {
    name: "GIMBAL_MANAGER_CAP_FLAGS",
    isBitmask: true,
    entries: [
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_RETRACT", value: 1 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_NEUTRAL", value: 2 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_ROLL_AXIS", value: 4 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_ROLL_FOLLOW", value: 8 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_ROLL_LOCK", value: 16 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_PITCH_AXIS", value: 32 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_PITCH_FOLLOW", value: 64 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_PITCH_LOCK", value: 128 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_YAW_AXIS", value: 256 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_YAW_FOLLOW", value: 512 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_YAW_LOCK", value: 1024 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_SUPPORTS_INFINITE_YAW", value: 2048 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_SUPPORTS_YAW_IN_EARTH_FRAME", value: 4096 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_HAS_RC_INPUTS", value: 8192 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_CAN_POINT_LOCATION_LOCAL", value: 65536 },
      { name: "GIMBAL_MANAGER_CAP_FLAGS_CAN_POINT_LOCATION_GLOBAL", value: 131072 },
    ],
  },
  {
    name: "GIMBAL_MANAGER_FLAGS",
    isBitmask: true,
    entries: [
      { name: "GIMBAL_MANAGER_FLAGS_RETRACT", value: 1 },
      { name: "GIMBAL_MANAGER_FLAGS_NEUTRAL", value: 2 },
      { name: "GIMBAL_MANAGER_FLAGS_ROLL_LOCK", value: 4 },
      { name: "GIMBAL_MANAGER_FLAGS_PITCH_LOCK", value: 8 },
      { name: "GIMBAL_MANAGER_FLAGS_YAW_LOCK", value: 16 },
      { name: "GIMBAL_MANAGER_FLAGS_YAW_IN_VEHICLE_FRAME", value: 32 },
      { name: "GIMBAL_MANAGER_FLAGS_YAW_IN_EARTH_FRAME", value: 64 },
      { name: "GIMBAL_MANAGER_FLAGS_ACCEPTS_YAW_IN_EARTH_FRAME", value: 128 },
      { name: "GIMBAL_MANAGER_FLAGS_RC_EXCLUSIVE", value: 256 },
      { name: "GIMBAL_MANAGER_FLAGS_RC_MIXED", value: 512 },
    ],
  },
  {
    name: "GLOBAL_POSITION_FLAGS",
    isBitmask: true,
    entries: [
      { name: "GLOBAL_POSITION_UNHEALTHY", value: 1 },
      { name: "GLOBAL_POSITION_PRIMARY", value: 2 },
    ],
  },
  {
    name: "GLOBAL_POSITION_SRC",
    isBitmask: false,
    entries: [
      { name: "GLOBAL_POSITION_SRC_UNKNOWN", value: 0 },
      { name: "GLOBAL_POSITION_SRC_GNSS", value: 1 },
      { name: "GLOBAL_POSITION_SRC_VISION", value: 2 },
      { name: "GLOBAL_POSITION_SRC_PSEUDOLITES", value: 3 },
      { name: "GLOBAL_POSITION_SRC_TERRAIN", value: 4 },
      { name: "GLOBAL_POSITION_SRC_MAGNETIC", value: 5 },
      { name: "GLOBAL_POSITION_SRC_ESTIMATOR", value: 6 },
      { name: "GLOBAL_POSITION_SRC_LEO", value: 7 },
    ],
  },
  {
    name: "GOPRO_BURST_RATE",
    isBitmask: false,
    entries: [
      { name: "GOPRO_BURST_RATE_3_IN_1_SECOND", value: 0 },
      { name: "GOPRO_BURST_RATE_5_IN_1_SECOND", value: 1 },
      { name: "GOPRO_BURST_RATE_10_IN_1_SECOND", value: 2 },
      { name: "GOPRO_BURST_RATE_10_IN_2_SECOND", value: 3 },
      { name: "GOPRO_BURST_RATE_10_IN_3_SECOND", value: 4 },
      { name: "GOPRO_BURST_RATE_30_IN_1_SECOND", value: 5 },
      { name: "GOPRO_BURST_RATE_30_IN_2_SECOND", value: 6 },
      { name: "GOPRO_BURST_RATE_30_IN_3_SECOND", value: 7 },
      { name: "GOPRO_BURST_RATE_30_IN_6_SECOND", value: 8 },
    ],
  },
  {
    name: "GOPRO_CAPTURE_MODE",
    isBitmask: false,
    entries: [
      { name: "GOPRO_CAPTURE_MODE_VIDEO", value: 0 },
      { name: "GOPRO_CAPTURE_MODE_PHOTO", value: 1 },
      { name: "GOPRO_CAPTURE_MODE_BURST", value: 2 },
      { name: "GOPRO_CAPTURE_MODE_TIME_LAPSE", value: 3 },
      { name: "GOPRO_CAPTURE_MODE_MULTI_SHOT", value: 4 },
      { name: "GOPRO_CAPTURE_MODE_PLAYBACK", value: 5 },
      { name: "GOPRO_CAPTURE_MODE_SETUP", value: 6 },
      { name: "GOPRO_CAPTURE_MODE_UNKNOWN", value: 255 },
    ],
  },
  {
    name: "GOPRO_CHARGING",
    isBitmask: false,
    entries: [
      { name: "GOPRO_CHARGING_DISABLED", value: 0 },
      { name: "GOPRO_CHARGING_ENABLED", value: 1 },
    ],
  },
  {
    name: "GOPRO_COMMAND",
    isBitmask: false,
    entries: [
      { name: "GOPRO_COMMAND_POWER", value: 0 },
      { name: "GOPRO_COMMAND_CAPTURE_MODE", value: 1 },
      { name: "GOPRO_COMMAND_SHUTTER", value: 2 },
      { name: "GOPRO_COMMAND_BATTERY", value: 3 },
      { name: "GOPRO_COMMAND_MODEL", value: 4 },
      { name: "GOPRO_COMMAND_VIDEO_SETTINGS", value: 5 },
      { name: "GOPRO_COMMAND_LOW_LIGHT", value: 6 },
      { name: "GOPRO_COMMAND_PHOTO_RESOLUTION", value: 7 },
      { name: "GOPRO_COMMAND_PHOTO_BURST_RATE", value: 8 },
      { name: "GOPRO_COMMAND_PROTUNE", value: 9 },
      { name: "GOPRO_COMMAND_PROTUNE_WHITE_BALANCE", value: 10 },
      { name: "GOPRO_COMMAND_PROTUNE_COLOUR", value: 11 },
      { name: "GOPRO_COMMAND_PROTUNE_GAIN", value: 12 },
      { name: "GOPRO_COMMAND_PROTUNE_SHARPNESS", value: 13 },
      { name: "GOPRO_COMMAND_PROTUNE_EXPOSURE", value: 14 },
      { name: "GOPRO_COMMAND_TIME", value: 15 },
      { name: "GOPRO_COMMAND_CHARGING", value: 16 },
    ],
  },
  {
    name: "GOPRO_FIELD_OF_VIEW",
    isBitmask: false,
    entries: [
      { name: "GOPRO_FIELD_OF_VIEW_WIDE", value: 0 },
      { name: "GOPRO_FIELD_OF_VIEW_MEDIUM", value: 1 },
      { name: "GOPRO_FIELD_OF_VIEW_NARROW", value: 2 },
    ],
  },
  {
    name: "GOPRO_FRAME_RATE",
    isBitmask: false,
    entries: [
      { name: "GOPRO_FRAME_RATE_12", value: 0 },
      { name: "GOPRO_FRAME_RATE_15", value: 1 },
      { name: "GOPRO_FRAME_RATE_24", value: 2 },
      { name: "GOPRO_FRAME_RATE_25", value: 3 },
      { name: "GOPRO_FRAME_RATE_30", value: 4 },
      { name: "GOPRO_FRAME_RATE_48", value: 5 },
      { name: "GOPRO_FRAME_RATE_50", value: 6 },
      { name: "GOPRO_FRAME_RATE_60", value: 7 },
      { name: "GOPRO_FRAME_RATE_80", value: 8 },
      { name: "GOPRO_FRAME_RATE_90", value: 9 },
      { name: "GOPRO_FRAME_RATE_100", value: 10 },
      { name: "GOPRO_FRAME_RATE_120", value: 11 },
      { name: "GOPRO_FRAME_RATE_240", value: 12 },
      { name: "GOPRO_FRAME_RATE_12_5", value: 13 },
    ],
  },
  {
    name: "GOPRO_HEARTBEAT_FLAGS",
    isBitmask: true,
    entries: [
      { name: "GOPRO_FLAG_RECORDING", value: 1 },
    ],
  },
  {
    name: "GOPRO_HEARTBEAT_STATUS",
    isBitmask: false,
    entries: [
      { name: "GOPRO_HEARTBEAT_STATUS_DISCONNECTED", value: 0 },
      { name: "GOPRO_HEARTBEAT_STATUS_INCOMPATIBLE", value: 1 },
      { name: "GOPRO_HEARTBEAT_STATUS_CONNECTED", value: 2 },
      { name: "GOPRO_HEARTBEAT_STATUS_ERROR", value: 3 },
    ],
  },
  {
    name: "GOPRO_MODEL",
    isBitmask: false,
    entries: [
      { name: "GOPRO_MODEL_UNKNOWN", value: 0 },
      { name: "GOPRO_MODEL_HERO_3_PLUS_SILVER", value: 1 },
      { name: "GOPRO_MODEL_HERO_3_PLUS_BLACK", value: 2 },
      { name: "GOPRO_MODEL_HERO_4_SILVER", value: 3 },
      { name: "GOPRO_MODEL_HERO_4_BLACK", value: 4 },
    ],
  },
  {
    name: "GOPRO_PHOTO_RESOLUTION",
    isBitmask: false,
    entries: [
      { name: "GOPRO_PHOTO_RESOLUTION_5MP_MEDIUM", value: 0 },
      { name: "GOPRO_PHOTO_RESOLUTION_7MP_MEDIUM", value: 1 },
      { name: "GOPRO_PHOTO_RESOLUTION_7MP_WIDE", value: 2 },
      { name: "GOPRO_PHOTO_RESOLUTION_10MP_WIDE", value: 3 },
      { name: "GOPRO_PHOTO_RESOLUTION_12MP_WIDE", value: 4 },
    ],
  },
  {
    name: "GOPRO_PROTUNE_COLOUR",
    isBitmask: false,
    entries: [
      { name: "GOPRO_PROTUNE_COLOUR_STANDARD", value: 0 },
      { name: "GOPRO_PROTUNE_COLOUR_NEUTRAL", value: 1 },
    ],
  },
  {
    name: "GOPRO_PROTUNE_EXPOSURE",
    isBitmask: false,
    entries: [
      { name: "GOPRO_PROTUNE_EXPOSURE_NEG_5_0", value: 0 },
      { name: "GOPRO_PROTUNE_EXPOSURE_NEG_4_5", value: 1 },
      { name: "GOPRO_PROTUNE_EXPOSURE_NEG_4_0", value: 2 },
      { name: "GOPRO_PROTUNE_EXPOSURE_NEG_3_5", value: 3 },
      { name: "GOPRO_PROTUNE_EXPOSURE_NEG_3_0", value: 4 },
      { name: "GOPRO_PROTUNE_EXPOSURE_NEG_2_5", value: 5 },
      { name: "GOPRO_PROTUNE_EXPOSURE_NEG_2_0", value: 6 },
      { name: "GOPRO_PROTUNE_EXPOSURE_NEG_1_5", value: 7 },
      { name: "GOPRO_PROTUNE_EXPOSURE_NEG_1_0", value: 8 },
      { name: "GOPRO_PROTUNE_EXPOSURE_NEG_0_5", value: 9 },
      { name: "GOPRO_PROTUNE_EXPOSURE_ZERO", value: 10 },
      { name: "GOPRO_PROTUNE_EXPOSURE_POS_0_5", value: 11 },
      { name: "GOPRO_PROTUNE_EXPOSURE_POS_1_0", value: 12 },
      { name: "GOPRO_PROTUNE_EXPOSURE_POS_1_5", value: 13 },
      { name: "GOPRO_PROTUNE_EXPOSURE_POS_2_0", value: 14 },
      { name: "GOPRO_PROTUNE_EXPOSURE_POS_2_5", value: 15 },
      { name: "GOPRO_PROTUNE_EXPOSURE_POS_3_0", value: 16 },
      { name: "GOPRO_PROTUNE_EXPOSURE_POS_3_5", value: 17 },
      { name: "GOPRO_PROTUNE_EXPOSURE_POS_4_0", value: 18 },
      { name: "GOPRO_PROTUNE_EXPOSURE_POS_4_5", value: 19 },
      { name: "GOPRO_PROTUNE_EXPOSURE_POS_5_0", value: 20 },
    ],
  },
  {
    name: "GOPRO_PROTUNE_GAIN",
    isBitmask: false,
    entries: [
      { name: "GOPRO_PROTUNE_GAIN_400", value: 0 },
      { name: "GOPRO_PROTUNE_GAIN_800", value: 1 },
      { name: "GOPRO_PROTUNE_GAIN_1600", value: 2 },
      { name: "GOPRO_PROTUNE_GAIN_3200", value: 3 },
      { name: "GOPRO_PROTUNE_GAIN_6400", value: 4 },
    ],
  },
  {
    name: "GOPRO_PROTUNE_SHARPNESS",
    isBitmask: false,
    entries: [
      { name: "GOPRO_PROTUNE_SHARPNESS_LOW", value: 0 },
      { name: "GOPRO_PROTUNE_SHARPNESS_MEDIUM", value: 1 },
      { name: "GOPRO_PROTUNE_SHARPNESS_HIGH", value: 2 },
    ],
  },
  {
    name: "GOPRO_PROTUNE_WHITE_BALANCE",
    isBitmask: false,
    entries: [
      { name: "GOPRO_PROTUNE_WHITE_BALANCE_AUTO", value: 0 },
      { name: "GOPRO_PROTUNE_WHITE_BALANCE_3000K", value: 1 },
      { name: "GOPRO_PROTUNE_WHITE_BALANCE_5500K", value: 2 },
      { name: "GOPRO_PROTUNE_WHITE_BALANCE_6500K", value: 3 },
      { name: "GOPRO_PROTUNE_WHITE_BALANCE_RAW", value: 4 },
    ],
  },
  {
    name: "GOPRO_REQUEST_STATUS",
    isBitmask: false,
    entries: [
      { name: "GOPRO_REQUEST_SUCCESS", value: 0 },
      { name: "GOPRO_REQUEST_FAILED", value: 1 },
    ],
  },
  {
    name: "GOPRO_RESOLUTION",
    isBitmask: false,
    entries: [
      { name: "GOPRO_RESOLUTION_480p", value: 0 },
      { name: "GOPRO_RESOLUTION_720p", value: 1 },
      { name: "GOPRO_RESOLUTION_960p", value: 2 },
      { name: "GOPRO_RESOLUTION_1080p", value: 3 },
      { name: "GOPRO_RESOLUTION_1440p", value: 4 },
      { name: "GOPRO_RESOLUTION_2_7k_17_9", value: 5 },
      { name: "GOPRO_RESOLUTION_2_7k_16_9", value: 6 },
      { name: "GOPRO_RESOLUTION_2_7k_4_3", value: 7 },
      { name: "GOPRO_RESOLUTION_4k_16_9", value: 8 },
      { name: "GOPRO_RESOLUTION_4k_17_9", value: 9 },
      { name: "GOPRO_RESOLUTION_720p_SUPERVIEW", value: 10 },
      { name: "GOPRO_RESOLUTION_1080p_SUPERVIEW", value: 11 },
      { name: "GOPRO_RESOLUTION_2_7k_SUPERVIEW", value: 12 },
      { name: "GOPRO_RESOLUTION_4k_SUPERVIEW", value: 13 },
    ],
  },
  {
    name: "GOPRO_VIDEO_SETTINGS_FLAGS",
    isBitmask: true,
    entries: [
      { name: "GOPRO_VIDEO_SETTINGS_TV_MODE", value: 1 },
    ],
  },
  {
    name: "GPS_FIX_TYPE",
    isBitmask: false,
    entries: [
      { name: "GPS_FIX_TYPE_NO_GPS", value: 0 },
      { name: "GPS_FIX_TYPE_NO_FIX", value: 1 },
      { name: "GPS_FIX_TYPE_2D_FIX", value: 2 },
      { name: "GPS_FIX_TYPE_3D_FIX", value: 3 },
      { name: "GPS_FIX_TYPE_DGPS", value: 4 },
      { name: "GPS_FIX_TYPE_RTK_FLOAT", value: 5 },
      { name: "GPS_FIX_TYPE_RTK_FIXED", value: 6 },
      { name: "GPS_FIX_TYPE_STATIC", value: 7 },
      { name: "GPS_FIX_TYPE_PPP", value: 8 },
    ],
  },
  {
    name: "GPS_INPUT_IGNORE_FLAGS",
    isBitmask: true,
    entries: [
      { name: "GPS_INPUT_IGNORE_FLAG_ALT", value: 1 },
      { name: "GPS_INPUT_IGNORE_FLAG_HDOP", value: 2 },
      { name: "GPS_INPUT_IGNORE_FLAG_VDOP", value: 4 },
      { name: "GPS_INPUT_IGNORE_FLAG_VEL_HORIZ", value: 8 },
      { name: "GPS_INPUT_IGNORE_FLAG_VEL_VERT", value: 16 },
      { name: "GPS_INPUT_IGNORE_FLAG_SPEED_ACCURACY", value: 32 },
      { name: "GPS_INPUT_IGNORE_FLAG_HORIZONTAL_ACCURACY", value: 64 },
      { name: "GPS_INPUT_IGNORE_FLAG_VERTICAL_ACCURACY", value: 128 },
    ],
  },
  {
    name: "GRIPPER_ACTIONS",
    isBitmask: false,
    entries: [
      { name: "GRIPPER_ACTION_RELEASE", value: 0 },
      { name: "GRIPPER_ACTION_GRAB", value: 1 },
      { name: "GRIPPER_ACTION_HOLD", value: 2 },
    ],
  },
  {
    name: "HEADING_TYPE",
    isBitmask: false,
    entries: [
      { name: "HEADING_TYPE_COURSE_OVER_GROUND", value: 0 },
      { name: "HEADING_TYPE_HEADING", value: 1 },
      { name: "HEADING_TYPE_DEFAULT", value: 2 },
    ],
  },
  {
    name: "HIGHRES_IMU_UPDATED_FLAGS",
    isBitmask: true,
    entries: [
      { name: "HIGHRES_IMU_UPDATED_XACC", value: 1 },
      { name: "HIGHRES_IMU_UPDATED_YACC", value: 2 },
      { name: "HIGHRES_IMU_UPDATED_ZACC", value: 4 },
      { name: "HIGHRES_IMU_UPDATED_XGYRO", value: 8 },
      { name: "HIGHRES_IMU_UPDATED_YGYRO", value: 16 },
      { name: "HIGHRES_IMU_UPDATED_ZGYRO", value: 32 },
      { name: "HIGHRES_IMU_UPDATED_XMAG", value: 64 },
      { name: "HIGHRES_IMU_UPDATED_YMAG", value: 128 },
      { name: "HIGHRES_IMU_UPDATED_ZMAG", value: 256 },
      { name: "HIGHRES_IMU_UPDATED_ABS_PRESSURE", value: 512 },
      { name: "HIGHRES_IMU_UPDATED_DIFF_PRESSURE", value: 1024 },
      { name: "HIGHRES_IMU_UPDATED_PRESSURE_ALT", value: 2048 },
      { name: "HIGHRES_IMU_UPDATED_TEMPERATURE", value: 4096 },
    ],
  },
  {
    name: "HIL_ACTUATOR_CONTROLS_FLAGS",
    isBitmask: true,
    entries: [
      { name: "HIL_ACTUATOR_CONTROLS_FLAGS_LOCKSTEP", value: 1 },
    ],
  },
  {
    name: "HIL_SENSOR_UPDATED_FLAGS",
    isBitmask: true,
    entries: [
      { name: "HIL_SENSOR_UPDATED_XACC", value: 1 },
      { name: "HIL_SENSOR_UPDATED_YACC", value: 2 },
      { name: "HIL_SENSOR_UPDATED_ZACC", value: 4 },
      { name: "HIL_SENSOR_UPDATED_XGYRO", value: 8 },
      { name: "HIL_SENSOR_UPDATED_YGYRO", value: 16 },
      { name: "HIL_SENSOR_UPDATED_ZGYRO", value: 32 },
      { name: "HIL_SENSOR_UPDATED_XMAG", value: 64 },
      { name: "HIL_SENSOR_UPDATED_YMAG", value: 128 },
      { name: "HIL_SENSOR_UPDATED_ZMAG", value: 256 },
      { name: "HIL_SENSOR_UPDATED_ABS_PRESSURE", value: 512 },
      { name: "HIL_SENSOR_UPDATED_DIFF_PRESSURE", value: 1024 },
      { name: "HIL_SENSOR_UPDATED_PRESSURE_ALT", value: 2048 },
      { name: "HIL_SENSOR_UPDATED_TEMPERATURE", value: 4096 },
      { name: "HIL_SENSOR_UPDATED_RESET", value: 2147483648 },
    ],
  },
  {
    name: "HL_FAILURE_FLAG",
    isBitmask: true,
    entries: [
      { name: "HL_FAILURE_FLAG_GPS", value: 1 },
      { name: "HL_FAILURE_FLAG_DIFFERENTIAL_PRESSURE", value: 2 },
      { name: "HL_FAILURE_FLAG_ABSOLUTE_PRESSURE", value: 4 },
      { name: "HL_FAILURE_FLAG_3D_ACCEL", value: 8 },
      { name: "HL_FAILURE_FLAG_3D_GYRO", value: 16 },
      { name: "HL_FAILURE_FLAG_3D_MAG", value: 32 },
      { name: "HL_FAILURE_FLAG_TERRAIN", value: 64 },
      { name: "HL_FAILURE_FLAG_BATTERY", value: 128 },
      { name: "HL_FAILURE_FLAG_RC_RECEIVER", value: 256 },
      { name: "HL_FAILURE_FLAG_OFFBOARD_LINK", value: 512 },
      { name: "HL_FAILURE_FLAG_ENGINE", value: 1024 },
      { name: "HL_FAILURE_FLAG_GEOFENCE", value: 2048 },
      { name: "HL_FAILURE_FLAG_ESTIMATOR", value: 4096 },
      { name: "HL_FAILURE_FLAG_MISSION", value: 8192 },
    ],
  },
  {
    name: "ICAROUS_FMS_STATE",
    isBitmask: false,
    entries: [
      { name: "ICAROUS_FMS_STATE_IDLE", value: 0 },
      { name: "ICAROUS_FMS_STATE_TAKEOFF", value: 1 },
      { name: "ICAROUS_FMS_STATE_CLIMB", value: 2 },
      { name: "ICAROUS_FMS_STATE_CRUISE", value: 3 },
      { name: "ICAROUS_FMS_STATE_APPROACH", value: 4 },
      { name: "ICAROUS_FMS_STATE_LAND", value: 5 },
    ],
  },
  {
    name: "ICAROUS_TRACK_BAND_TYPES",
    isBitmask: false,
    entries: [
      { name: "ICAROUS_TRACK_BAND_TYPE_NONE", value: 0 },
      { name: "ICAROUS_TRACK_BAND_TYPE_NEAR", value: 1 },
      { name: "ICAROUS_TRACK_BAND_TYPE_RECOVERY", value: 2 },
    ],
  },
  {
    name: "ILLUMINATOR_ERROR_FLAGS",
    isBitmask: true,
    entries: [
      { name: "ILLUMINATOR_ERROR_FLAGS_THERMAL_THROTTLING", value: 1 },
      { name: "ILLUMINATOR_ERROR_FLAGS_OVER_TEMPERATURE_SHUTDOWN", value: 2 },
      { name: "ILLUMINATOR_ERROR_FLAGS_THERMISTOR_FAILURE", value: 4 },
    ],
  },
  {
    name: "ILLUMINATOR_MODE",
    isBitmask: false,
    entries: [
      { name: "ILLUMINATOR_MODE_UNKNOWN", value: 0 },
      { name: "ILLUMINATOR_MODE_INTERNAL_CONTROL", value: 1 },
      { name: "ILLUMINATOR_MODE_EXTERNAL_SYNC", value: 2 },
    ],
  },
  {
    name: "LANDING_TARGET_TYPE",
    isBitmask: false,
    entries: [
      { name: "LANDING_TARGET_TYPE_LIGHT_BEACON", value: 0 },
      { name: "LANDING_TARGET_TYPE_RADIO_BEACON", value: 1 },
      { name: "LANDING_TARGET_TYPE_VISION_FIDUCIAL", value: 2 },
      { name: "LANDING_TARGET_TYPE_VISION_OTHER", value: 3 },
    ],
  },
  {
    name: "LED_CONTROL_PATTERN",
    isBitmask: false,
    entries: [
      { name: "LED_CONTROL_PATTERN_OFF", value: 0 },
      { name: "LED_CONTROL_PATTERN_FIRMWAREUPDATE", value: 1 },
      { name: "LED_CONTROL_PATTERN_CUSTOM", value: 255 },
    ],
  },
  {
    name: "LIMIT_MODULE",
    isBitmask: true,
    entries: [
      { name: "LIMIT_GPSLOCK", value: 1 },
      { name: "LIMIT_GEOFENCE", value: 2 },
      { name: "LIMIT_ALTITUDE", value: 4 },
    ],
  },
  {
    name: "LIMITS_STATE",
    isBitmask: false,
    entries: [
      { name: "LIMITS_INIT", value: 0 },
      { name: "LIMITS_DISABLED", value: 1 },
      { name: "LIMITS_ENABLED", value: 2 },
      { name: "LIMITS_TRIGGERED", value: 3 },
      { name: "LIMITS_RECOVERING", value: 4 },
      { name: "LIMITS_RECOVERED", value: 5 },
    ],
  },
  {
    name: "MAG_CAL_STATUS",
    isBitmask: false,
    entries: [
      { name: "MAG_CAL_NOT_STARTED", value: 0 },
      { name: "MAG_CAL_WAITING_TO_START", value: 1 },
      { name: "MAG_CAL_RUNNING_STEP_ONE", value: 2 },
      { name: "MAG_CAL_RUNNING_STEP_TWO", value: 3 },
      { name: "MAG_CAL_SUCCESS", value: 4 },
      { name: "MAG_CAL_FAILED", value: 5 },
      { name: "MAG_CAL_FAILED_ORIENTATION", value: 6 },
      { name: "MAG_CAL_FAILED_RADIUS", value: 7 },
      { name: "MAG_CAL_FAILED_OFFSETS", value: 8 },
      { name: "MAG_CAL_FAILED_DIAG_SCALING", value: 9 },
      { name: "MAG_CAL_FAILED_RESIDUALS_HIGH", value: 10 },
    ],
  },
  {
    name: "MAV_ARM_AUTH_DENIED_REASON",
    isBitmask: false,
    entries: [
      { name: "MAV_ARM_AUTH_DENIED_REASON_GENERIC", value: 0 },
      { name: "MAV_ARM_AUTH_DENIED_REASON_NONE", value: 1 },
      { name: "MAV_ARM_AUTH_DENIED_REASON_INVALID_WAYPOINT", value: 2 },
      { name: "MAV_ARM_AUTH_DENIED_REASON_TIMEOUT", value: 3 },
      { name: "MAV_ARM_AUTH_DENIED_REASON_AIRSPACE_IN_USE", value: 4 },
      { name: "MAV_ARM_AUTH_DENIED_REASON_BAD_WEATHER", value: 5 },
    ],
  },
  {
    name: "MAV_AUTOPILOT",
    isBitmask: false,
    entries: [
      { name: "MAV_AUTOPILOT_GENERIC", value: 0 },
      { name: "MAV_AUTOPILOT_RESERVED", value: 1 },
      { name: "MAV_AUTOPILOT_SLUGS", value: 2 },
      { name: "MAV_AUTOPILOT_ARDUPILOTMEGA", value: 3 },
      { name: "MAV_AUTOPILOT_OPENPILOT", value: 4 },
      { name: "MAV_AUTOPILOT_GENERIC_WAYPOINTS_ONLY", value: 5 },
      { name: "MAV_AUTOPILOT_GENERIC_WAYPOINTS_AND_SIMPLE_NAVIGATION_ONLY", value: 6 },
      { name: "MAV_AUTOPILOT_GENERIC_MISSION_FULL", value: 7 },
      { name: "MAV_AUTOPILOT_INVALID", value: 8 },
      { name: "MAV_AUTOPILOT_PPZ", value: 9 },
      { name: "MAV_AUTOPILOT_UDB", value: 10 },
      { name: "MAV_AUTOPILOT_FP", value: 11 },
      { name: "MAV_AUTOPILOT_PX4", value: 12 },
      { name: "MAV_AUTOPILOT_SMACCMPILOT", value: 13 },
      { name: "MAV_AUTOPILOT_AUTOQUAD", value: 14 },
      { name: "MAV_AUTOPILOT_ARMAZILA", value: 15 },
      { name: "MAV_AUTOPILOT_AEROB", value: 16 },
      { name: "MAV_AUTOPILOT_ASLUAV", value: 17 },
      { name: "MAV_AUTOPILOT_SMARTAP", value: 18 },
      { name: "MAV_AUTOPILOT_AIRRAILS", value: 19 },
      { name: "MAV_AUTOPILOT_REFLEX", value: 20 },
      { name: "MAV_AUTOPILOT_FLIX", value: 21 },
    ],
  },
  {
    name: "MAV_BATTERY_CHARGE_STATE",
    isBitmask: false,
    entries: [
      { name: "MAV_BATTERY_CHARGE_STATE_UNDEFINED", value: 0 },
      { name: "MAV_BATTERY_CHARGE_STATE_OK", value: 1 },
      { name: "MAV_BATTERY_CHARGE_STATE_LOW", value: 2 },
      { name: "MAV_BATTERY_CHARGE_STATE_CRITICAL", value: 3 },
      { name: "MAV_BATTERY_CHARGE_STATE_EMERGENCY", value: 4 },
      { name: "MAV_BATTERY_CHARGE_STATE_FAILED", value: 5 },
      { name: "MAV_BATTERY_CHARGE_STATE_UNHEALTHY", value: 6 },
      { name: "MAV_BATTERY_CHARGE_STATE_CHARGING", value: 7 },
    ],
  },
  {
    name: "MAV_BATTERY_FAULT",
    isBitmask: true,
    entries: [
      { name: "MAV_BATTERY_FAULT_DEEP_DISCHARGE", value: 1 },
      { name: "MAV_BATTERY_FAULT_SPIKES", value: 2 },
      { name: "MAV_BATTERY_FAULT_CELL_FAIL", value: 4 },
      { name: "MAV_BATTERY_FAULT_OVER_CURRENT", value: 8 },
      { name: "MAV_BATTERY_FAULT_OVER_TEMPERATURE", value: 16 },
      { name: "MAV_BATTERY_FAULT_UNDER_TEMPERATURE", value: 32 },
      { name: "MAV_BATTERY_FAULT_INCOMPATIBLE_VOLTAGE", value: 64 },
      { name: "MAV_BATTERY_FAULT_INCOMPATIBLE_FIRMWARE", value: 128 },
      { name: "BATTERY_FAULT_INCOMPATIBLE_CELLS_CONFIGURATION", value: 256 },
    ],
  },
  {
    name: "MAV_BATTERY_FUNCTION",
    isBitmask: false,
    entries: [
      { name: "MAV_BATTERY_FUNCTION_UNKNOWN", value: 0 },
      { name: "MAV_BATTERY_FUNCTION_ALL", value: 1 },
      { name: "MAV_BATTERY_FUNCTION_PROPULSION", value: 2 },
      { name: "MAV_BATTERY_FUNCTION_AVIONICS", value: 3 },
      { name: "MAV_BATTERY_FUNCTION_PAYLOAD", value: 4 },
    ],
  },
  {
    name: "MAV_BATTERY_MODE",
    isBitmask: false,
    entries: [
      { name: "MAV_BATTERY_MODE_UNKNOWN", value: 0 },
      { name: "MAV_BATTERY_MODE_AUTO_DISCHARGING", value: 1 },
      { name: "MAV_BATTERY_MODE_HOT_SWAP", value: 2 },
    ],
  },
  {
    name: "MAV_BATTERY_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_BATTERY_TYPE_UNKNOWN", value: 0 },
      { name: "MAV_BATTERY_TYPE_LIPO", value: 1 },
      { name: "MAV_BATTERY_TYPE_LIFE", value: 2 },
      { name: "MAV_BATTERY_TYPE_LION", value: 3 },
      { name: "MAV_BATTERY_TYPE_NIMH", value: 4 },
    ],
  },
  {
    name: "MAV_BOOL",
    isBitmask: false,
    entries: [
      { name: "MAV_BOOL_FALSE", value: 0 },
      { name: "MAV_BOOL_TRUE", value: 1 },
    ],
  },
  {
    name: "MAV_CMD",
    isBitmask: false,
    entries: [
      { name: "MAV_CMD_NAV_WAYPOINT", value: 16, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_LOITER_UNLIM", value: 17, command: true, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_LOITER_TURNS", value: 18, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_LOITER_TIME", value: 19, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_RETURN_TO_LAUNCH", value: 20, command: true, mission: true },
      { name: "MAV_CMD_NAV_LAND", value: 21, command: true, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_TAKEOFF", value: 22, command: true, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_LAND_LOCAL", value: 23, command: true, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_TAKEOFF_LOCAL", value: 24, command: true, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_CONTINUE_AND_CHANGE_ALT", value: 30, mission: true },
      { name: "MAV_CMD_NAV_LOITER_TO_ALT", value: 31, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_DO_FOLLOW", value: 32, command: true },
      { name: "MAV_CMD_DO_FOLLOW_REPOSITION", value: 33, command: true },
      { name: "MAV_CMD_DO_ORBIT", value: 34, command: true, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_DO_FIGURE_EIGHT", value: 35, command: true, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_ARC_WAYPOINT", value: 36, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_ROI", value: 80, command: true, mission: true, hasLocation: true },
      { name: "MAV_CMD_NAV_PATHPLANNING", value: 81, command: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_SPLINE_WAYPOINT", value: 82, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_ALTITUDE_WAIT", value: 83 },
      { name: "MAV_CMD_NAV_VTOL_TAKEOFF", value: 84, command: true, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_VTOL_LAND", value: 85, command: true, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_GUIDED_ENABLE", value: 92, command: true, mission: true },
      { name: "MAV_CMD_NAV_DELAY", value: 93, mission: true },
      { name: "MAV_CMD_NAV_PAYLOAD_PLACE", value: 94, command: true, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_NAV_LAST", value: 95 },
      { name: "MAV_CMD_CONDITION_DELAY", value: 112, mission: true },
      { name: "MAV_CMD_CONDITION_CHANGE_ALT", value: 113, mission: true },
      { name: "MAV_CMD_CONDITION_DISTANCE", value: 114, mission: true },
      { name: "MAV_CMD_CONDITION_YAW", value: 115, command: true, mission: true },
      { name: "MAV_CMD_CONDITION_LAST", value: 159 },
      { name: "MAV_CMD_DO_SET_MODE", value: 176, command: true },
      { name: "MAV_CMD_DO_JUMP", value: 177, mission: true },
      { name: "MAV_CMD_DO_CHANGE_SPEED", value: 178, command: true, mission: true },
      { name: "MAV_CMD_DO_SET_HOME", value: 179, command: true, mission: true, hasLocation: true },
      { name: "MAV_CMD_DO_SET_PARAMETER", value: 180, command: true },
      { name: "MAV_CMD_DO_SET_RELAY", value: 181, command: true, mission: true },
      { name: "MAV_CMD_DO_REPEAT_RELAY", value: 182, command: true, mission: true },
      { name: "MAV_CMD_DO_SET_SERVO", value: 183, command: true, mission: true },
      { name: "MAV_CMD_DO_REPEAT_SERVO", value: 184, command: true, mission: true },
      { name: "MAV_CMD_DO_FLIGHTTERMINATION", value: 185, command: true, mission: true },
      { name: "MAV_CMD_DO_CHANGE_ALTITUDE", value: 186, command: true },
      { name: "MAV_CMD_DO_SET_ACTUATOR", value: 187, command: true, mission: true },
      { name: "MAV_CMD_DO_RETURN_PATH_START", value: 188, command: true, mission: true, hasLocation: true },
      { name: "MAV_CMD_DO_LAND_START", value: 189, command: true, mission: true, hasLocation: true },
      { name: "MAV_CMD_DO_RALLY_LAND", value: 190, command: true, mission: true },
      { name: "MAV_CMD_DO_GO_AROUND", value: 191, command: true },
      { name: "MAV_CMD_DO_REPOSITION", value: 192, command: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_DO_PAUSE_CONTINUE", value: 193, command: true, mission: true },
      { name: "MAV_CMD_DO_SET_REVERSE", value: 194, command: true, mission: true },
      { name: "MAV_CMD_DO_SET_ROI_LOCATION", value: 195, command: true, mission: true, hasLocation: true },
      { name: "MAV_CMD_DO_SET_ROI_WPNEXT_OFFSET", value: 196, mission: true },
      { name: "MAV_CMD_DO_SET_ROI_NONE", value: 197, command: true, mission: true },
      { name: "MAV_CMD_DO_SET_ROI_SYSID", value: 198, command: true, mission: true },
      { name: "MAV_CMD_DO_CONTROL_VIDEO", value: 200, command: true, mission: true },
      { name: "MAV_CMD_DO_SET_ROI", value: 201, command: true, mission: true, hasLocation: true },
      { name: "MAV_CMD_DO_DIGICAM_CONFIGURE", value: 202, command: true, mission: true },
      { name: "MAV_CMD_DO_DIGICAM_CONTROL", value: 203, command: true, mission: true },
      { name: "MAV_CMD_DO_MOUNT_CONFIGURE", value: 204, command: true },
      { name: "MAV_CMD_DO_MOUNT_CONTROL", value: 205, command: true, mission: true },
      { name: "MAV_CMD_DO_SET_CAM_TRIGG_DIST", value: 206, command: true, mission: true },
      { name: "MAV_CMD_DO_FENCE_ENABLE", value: 207, command: true, mission: true },
      { name: "MAV_CMD_DO_PARACHUTE", value: 208, command: true, mission: true },
      { name: "MAV_CMD_DO_MOTOR_TEST", value: 209, command: true },
      { name: "MAV_CMD_DO_INVERTED_FLIGHT", value: 210, command: true, mission: true },
      { name: "MAV_CMD_DO_GRIPPER", value: 211, command: true, mission: true },
      { name: "MAV_CMD_DO_AUTOTUNE_ENABLE", value: 212, command: true, mission: true },
      { name: "MAV_CMD_NAV_SET_YAW_SPEED", value: 213, command: true, mission: true },
      { name: "MAV_CMD_DO_SET_CAM_TRIGG_INTERVAL", value: 214, command: true, mission: true },
      { name: "MAV_CMD_DO_SET_RESUME_REPEAT_DIST", value: 215 },
      { name: "MAV_CMD_DO_SPRAYER", value: 216 },
      { name: "MAV_CMD_DO_SEND_SCRIPT_MESSAGE", value: 217 },
      { name: "MAV_CMD_DO_AUX_FUNCTION", value: 218 },
      { name: "MAV_CMD_DO_MOUNT_CONTROL_QUAT", value: 220, command: true, mission: true },
      { name: "MAV_CMD_DO_GUIDED_MASTER", value: 221, command: true },
      { name: "MAV_CMD_DO_GUIDED_LIMITS", value: 222, command: true, mission: true },
      { name: "MAV_CMD_DO_ENGINE_CONTROL", value: 223, command: true, mission: true },
      { name: "MAV_CMD_DO_SET_MISSION_CURRENT", value: 224, command: true },
      { name: "MAV_CMD_DO_LAST", value: 240 },
      { name: "MAV_CMD_PREFLIGHT_CALIBRATION", value: 241, command: true },
      { name: "MAV_CMD_PREFLIGHT_SET_SENSOR_OFFSETS", value: 242, command: true },
      { name: "MAV_CMD_PREFLIGHT_UAVCAN", value: 243, command: true },
      { name: "MAV_CMD_PREFLIGHT_STORAGE", value: 245, command: true },
      { name: "MAV_CMD_PREFLIGHT_REBOOT_SHUTDOWN", value: 246, command: true },
      { name: "MAV_CMD_OVERRIDE_GOTO", value: 252, command: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_OBLIQUE_SURVEY", value: 260, command: true, mission: true },
      { name: "MAV_CMD_DO_SET_STANDARD_MODE", value: 262, command: true },
      { name: "MAV_CMD_MISSION_START", value: 300, command: true },
      { name: "MAV_CMD_ACTUATOR_TEST", value: 310, command: true },
      { name: "MAV_CMD_CONFIGURE_ACTUATOR", value: 311, command: true },
      { name: "MAV_CMD_COMPONENT_ARM_DISARM", value: 400, command: true },
      { name: "MAV_CMD_RUN_PREARM_CHECKS", value: 401, command: true },
      { name: "MAV_CMD_ILLUMINATOR_ON_OFF", value: 405, command: true, mission: true },
      { name: "MAV_CMD_DO_ILLUMINATOR_CONFIGURE", value: 406, command: true },
      { name: "MAV_CMD_GET_HOME_POSITION", value: 410, command: true },
      { name: "MAV_CMD_INJECT_FAILURE", value: 420, command: true, mission: true },
      { name: "MAV_CMD_START_RX_PAIR", value: 500, command: true },
      { name: "MAV_CMD_GET_MESSAGE_INTERVAL", value: 510, command: true },
      { name: "MAV_CMD_SET_MESSAGE_INTERVAL", value: 511, command: true },
      { name: "MAV_CMD_REQUEST_MESSAGE", value: 512, command: true },
      { name: "MAV_CMD_REQUEST_PROTOCOL_VERSION", value: 519, command: true },
      { name: "MAV_CMD_REQUEST_AUTOPILOT_CAPABILITIES", value: 520, command: true },
      { name: "MAV_CMD_REQUEST_CAMERA_INFORMATION", value: 521, command: true },
      { name: "MAV_CMD_REQUEST_CAMERA_SETTINGS", value: 522, command: true },
      { name: "MAV_CMD_REQUEST_STORAGE_INFORMATION", value: 525, command: true },
      { name: "MAV_CMD_STORAGE_FORMAT", value: 526, command: true },
      { name: "MAV_CMD_REQUEST_CAMERA_CAPTURE_STATUS", value: 527, command: true },
      { name: "MAV_CMD_REQUEST_FLIGHT_INFORMATION", value: 528, command: true },
      { name: "MAV_CMD_RESET_CAMERA_SETTINGS", value: 529, command: true },
      { name: "MAV_CMD_SET_CAMERA_MODE", value: 530, command: true, mission: true },
      { name: "MAV_CMD_SET_CAMERA_ZOOM", value: 531, command: true, mission: true },
      { name: "MAV_CMD_SET_CAMERA_FOCUS", value: 532, command: true, mission: true },
      { name: "MAV_CMD_SET_STORAGE_USAGE", value: 533, command: true },
      { name: "MAV_CMD_SET_CAMERA_SOURCE", value: 534, command: true, mission: true },
      { name: "MAV_CMD_JUMP_TAG", value: 600, mission: true },
      { name: "MAV_CMD_DO_JUMP_TAG", value: 601, mission: true },
      { name: "MAV_CMD_DO_SET_GLOBAL_ORIGIN", value: 611, command: true, hasLocation: true },
      { name: "MAV_CMD_DO_GIMBAL_MANAGER_PITCHYAW", value: 1000, command: true, mission: true },
      { name: "MAV_CMD_DO_GIMBAL_MANAGER_CONFIGURE", value: 1001, command: true },
      { name: "MAV_CMD_IMAGE_START_CAPTURE", value: 2000, command: true, mission: true },
      { name: "MAV_CMD_IMAGE_STOP_CAPTURE", value: 2001, command: true, mission: true },
      { name: "MAV_CMD_REQUEST_CAMERA_IMAGE_CAPTURE", value: 2002, command: true },
      { name: "MAV_CMD_DO_TRIGGER_CONTROL", value: 2003, command: true },
      { name: "MAV_CMD_CAMERA_TRACK_POINT", value: 2004, command: true },
      { name: "MAV_CMD_CAMERA_TRACK_RECTANGLE", value: 2005, command: true },
      { name: "MAV_CMD_CAMERA_STOP_TRACKING", value: 2010, command: true },
      { name: "MAV_CMD_VIDEO_START_CAPTURE", value: 2500, command: true, mission: true },
      { name: "MAV_CMD_VIDEO_STOP_CAPTURE", value: 2501, command: true, mission: true },
      { name: "MAV_CMD_VIDEO_START_STREAMING", value: 2502, command: true },
      { name: "MAV_CMD_VIDEO_STOP_STREAMING", value: 2503, command: true },
      { name: "MAV_CMD_REQUEST_VIDEO_STREAM_INFORMATION", value: 2504, command: true },
      { name: "MAV_CMD_REQUEST_VIDEO_STREAM_STATUS", value: 2505, command: true },
      { name: "MAV_CMD_LOGGING_START", value: 2510, command: true, mission: true },
      { name: "MAV_CMD_LOGGING_STOP", value: 2511, command: true, mission: true },
      { name: "MAV_CMD_AIRFRAME_CONFIGURATION", value: 2520, command: true },
      { name: "MAV_CMD_CONTROL_HIGH_LATENCY", value: 2600, command: true },
      { name: "MAV_CMD_PANORAMA_CREATE", value: 2800, command: true, mission: true },
      { name: "MAV_CMD_DO_VTOL_TRANSITION", value: 3000, command: true, mission: true },
      { name: "MAV_CMD_ARM_AUTHORIZATION_REQUEST", value: 3001, command: true },
      { name: "MAV_CMD_SET_GUIDED_SUBMODE_STANDARD", value: 4000, command: true },
      { name: "MAV_CMD_SET_GUIDED_SUBMODE_CIRCLE", value: 4001, command: true, hasLocation: true },
      { name: "MAV_CMD_CONDITION_GATE", value: 4501, mission: true, hasLocation: true },
      { name: "MAV_CMD_NAV_FENCE_RETURN_POINT", value: 5000, hasLocation: true, isDestination: true, fence: true },
      { name: "MAV_CMD_NAV_FENCE_POLYGON_VERTEX_INCLUSION", value: 5001, hasLocation: true, fence: true },
      { name: "MAV_CMD_NAV_FENCE_POLYGON_VERTEX_EXCLUSION", value: 5002, hasLocation: true, fence: true },
      { name: "MAV_CMD_NAV_FENCE_CIRCLE_INCLUSION", value: 5003, hasLocation: true, fence: true },
      { name: "MAV_CMD_NAV_FENCE_CIRCLE_EXCLUSION", value: 5004, hasLocation: true, fence: true },
      { name: "MAV_CMD_NAV_RALLY_POINT", value: 5100, hasLocation: true, rally: true },
      { name: "MAV_CMD_UAVCAN_GET_NODE_INFO", value: 5200, command: true },
      { name: "MAV_CMD_DO_SET_SAFETY_SWITCH_STATE", value: 5300, command: true },
      { name: "MAV_CMD_DO_ADSB_OUT_IDENT", value: 10001, command: true },
      { name: "MAV_CMD_PAYLOAD_PREPARE_DEPLOY", value: 30001, command: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_PAYLOAD_CONTROL_DEPLOY", value: 30002, command: true },
      { name: "MAV_CMD_WAYPOINT_USER_1", value: 31000, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_WAYPOINT_USER_2", value: 31001, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_WAYPOINT_USER_3", value: 31002, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_WAYPOINT_USER_4", value: 31003, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_WAYPOINT_USER_5", value: 31004, mission: true, hasLocation: true, isDestination: true },
      { name: "MAV_CMD_SPATIAL_USER_1", value: 31005, mission: true, hasLocation: true },
      { name: "MAV_CMD_SPATIAL_USER_2", value: 31006, mission: true, hasLocation: true },
      { name: "MAV_CMD_SPATIAL_USER_3", value: 31007, mission: true, hasLocation: true },
      { name: "MAV_CMD_SPATIAL_USER_4", value: 31008, mission: true, hasLocation: true },
      { name: "MAV_CMD_SPATIAL_USER_5", value: 31009, mission: true, hasLocation: true },
      { name: "MAV_CMD_USER_1", value: 31010, mission: true },
      { name: "MAV_CMD_USER_2", value: 31011, mission: true },
      { name: "MAV_CMD_USER_3", value: 31012, mission: true },
      { name: "MAV_CMD_USER_4", value: 31013, mission: true },
      { name: "MAV_CMD_USER_5", value: 31014, mission: true },
      { name: "MAV_CMD_CAN_FORWARD", value: 32000, command: true },
      { name: "MAV_CMD_POWER_OFF_INITIATED", value: 42000 },
      { name: "MAV_CMD_SOLO_BTN_FLY_CLICK", value: 42001 },
      { name: "MAV_CMD_SOLO_BTN_FLY_HOLD", value: 42002 },
      { name: "MAV_CMD_SOLO_BTN_PAUSE_CLICK", value: 42003 },
      { name: "MAV_CMD_FIXED_MAG_CAL", value: 42004 },
      { name: "MAV_CMD_FIXED_MAG_CAL_FIELD", value: 42005 },
      { name: "MAV_CMD_FIXED_MAG_CAL_YAW", value: 42006, command: true },
      { name: "MAV_CMD_SET_EKF_SOURCE_SET", value: 42007 },
      { name: "MAV_CMD_DO_START_MAG_CAL", value: 42424 },
      { name: "MAV_CMD_DO_ACCEPT_MAG_CAL", value: 42425 },
      { name: "MAV_CMD_DO_CANCEL_MAG_CAL", value: 42426 },
      { name: "MAV_CMD_SET_FACTORY_TEST_MODE", value: 42427 },
      { name: "MAV_CMD_DO_SEND_BANNER", value: 42428 },
      { name: "MAV_CMD_ACCELCAL_VEHICLE_POS", value: 42429 },
      { name: "MAV_CMD_GIMBAL_RESET", value: 42501 },
      { name: "MAV_CMD_GIMBAL_AXIS_CALIBRATION_STATUS", value: 42502 },
      { name: "MAV_CMD_GIMBAL_REQUEST_AXIS_CALIBRATION", value: 42503 },
      { name: "MAV_CMD_GIMBAL_FULL_RESET", value: 42505 },
      { name: "MAV_CMD_DO_WINCH", value: 42600, command: true, mission: true },
      { name: "MAV_CMD_FLASH_BOOTLOADER", value: 42650 },
      { name: "MAV_CMD_BATTERY_RESET", value: 42651 },
      { name: "MAV_CMD_DEBUG_TRAP", value: 42700 },
      { name: "MAV_CMD_SCRIPTING", value: 42701 },
      { name: "MAV_CMD_NAV_SCRIPT_TIME", value: 42702 },
      { name: "MAV_CMD_NAV_ATTITUDE_TIME", value: 42703 },
      { name: "MAV_CMD_GUIDED_CHANGE_SPEED", value: 43000, command: true },
      { name: "MAV_CMD_GUIDED_CHANGE_ALTITUDE", value: 43001, command: true },
      { name: "MAV_CMD_GUIDED_CHANGE_HEADING", value: 43002, command: true },
      { name: "MAV_CMD_EXTERNAL_POSITION_ESTIMATE", value: 43003, command: true, hasLocation: true },
      { name: "MAV_CMD_SET_HAGL", value: 43005 },
    ],
  },
  {
    name: "MAV_CMD_DO_AUX_FUNCTION_SWITCH_LEVEL",
    isBitmask: false,
    entries: [
      { name: "MAV_CMD_DO_AUX_FUNCTION_SWITCH_LEVEL_LOW", value: 0 },
      { name: "MAV_CMD_DO_AUX_FUNCTION_SWITCH_LEVEL_MIDDLE", value: 1 },
      { name: "MAV_CMD_DO_AUX_FUNCTION_SWITCH_LEVEL_HIGH", value: 2 },
    ],
  },
  {
    name: "MAV_COLLISION_ACTION",
    isBitmask: false,
    entries: [
      { name: "MAV_COLLISION_ACTION_NONE", value: 0 },
      { name: "MAV_COLLISION_ACTION_REPORT", value: 1 },
      { name: "MAV_COLLISION_ACTION_ASCEND_OR_DESCEND", value: 2 },
      { name: "MAV_COLLISION_ACTION_MOVE_HORIZONTALLY", value: 3 },
      { name: "MAV_COLLISION_ACTION_MOVE_PERPENDICULAR", value: 4 },
      { name: "MAV_COLLISION_ACTION_RTL", value: 5 },
      { name: "MAV_COLLISION_ACTION_HOVER", value: 6 },
    ],
  },
  {
    name: "MAV_COLLISION_SRC",
    isBitmask: false,
    entries: [
      { name: "MAV_COLLISION_SRC_ADSB", value: 0 },
      { name: "MAV_COLLISION_SRC_MAVLINK_GPS_GLOBAL_INT", value: 1 },
    ],
  },
  {
    name: "MAV_COLLISION_THREAT_LEVEL",
    isBitmask: false,
    entries: [
      { name: "MAV_COLLISION_THREAT_LEVEL_NONE", value: 0 },
      { name: "MAV_COLLISION_THREAT_LEVEL_LOW", value: 1 },
      { name: "MAV_COLLISION_THREAT_LEVEL_HIGH", value: 2 },
    ],
  },
  {
    name: "MAV_COMPONENT",
    isBitmask: false,
    entries: [
      { name: "MAV_COMP_ID_ALL", value: 0 },
      { name: "MAV_COMP_ID_AUTOPILOT1", value: 1 },
      { name: "MAV_COMP_ID_USER1", value: 25 },
      { name: "MAV_COMP_ID_USER2", value: 26 },
      { name: "MAV_COMP_ID_USER3", value: 27 },
      { name: "MAV_COMP_ID_USER4", value: 28 },
      { name: "MAV_COMP_ID_USER5", value: 29 },
      { name: "MAV_COMP_ID_USER6", value: 30 },
      { name: "MAV_COMP_ID_USER7", value: 31 },
      { name: "MAV_COMP_ID_USER8", value: 32 },
      { name: "MAV_COMP_ID_USER9", value: 33 },
      { name: "MAV_COMP_ID_USER10", value: 34 },
      { name: "MAV_COMP_ID_USER11", value: 35 },
      { name: "MAV_COMP_ID_USER12", value: 36 },
      { name: "MAV_COMP_ID_USER13", value: 37 },
      { name: "MAV_COMP_ID_USER14", value: 38 },
      { name: "MAV_COMP_ID_USER15", value: 39 },
      { name: "MAV_COMP_ID_USER16", value: 40 },
      { name: "MAV_COMP_ID_USER17", value: 41 },
      { name: "MAV_COMP_ID_USER18", value: 42 },
      { name: "MAV_COMP_ID_USER19", value: 43 },
      { name: "MAV_COMP_ID_USER20", value: 44 },
      { name: "MAV_COMP_ID_USER21", value: 45 },
      { name: "MAV_COMP_ID_USER22", value: 46 },
      { name: "MAV_COMP_ID_USER23", value: 47 },
      { name: "MAV_COMP_ID_USER24", value: 48 },
      { name: "MAV_COMP_ID_USER25", value: 49 },
      { name: "MAV_COMP_ID_USER26", value: 50 },
      { name: "MAV_COMP_ID_USER27", value: 51 },
      { name: "MAV_COMP_ID_USER28", value: 52 },
      { name: "MAV_COMP_ID_USER29", value: 53 },
      { name: "MAV_COMP_ID_USER30", value: 54 },
      { name: "MAV_COMP_ID_USER31", value: 55 },
      { name: "MAV_COMP_ID_USER32", value: 56 },
      { name: "MAV_COMP_ID_USER33", value: 57 },
      { name: "MAV_COMP_ID_USER34", value: 58 },
      { name: "MAV_COMP_ID_USER35", value: 59 },
      { name: "MAV_COMP_ID_USER36", value: 60 },
      { name: "MAV_COMP_ID_USER37", value: 61 },
      { name: "MAV_COMP_ID_USER38", value: 62 },
      { name: "MAV_COMP_ID_USER39", value: 63 },
      { name: "MAV_COMP_ID_USER40", value: 64 },
      { name: "MAV_COMP_ID_USER41", value: 65 },
      { name: "MAV_COMP_ID_USER42", value: 66 },
      { name: "MAV_COMP_ID_USER43", value: 67 },
      { name: "MAV_COMP_ID_TELEMETRY_RADIO", value: 68 },
      { name: "MAV_COMP_ID_USER45", value: 69 },
      { name: "MAV_COMP_ID_USER46", value: 70 },
      { name: "MAV_COMP_ID_USER47", value: 71 },
      { name: "MAV_COMP_ID_USER48", value: 72 },
      { name: "MAV_COMP_ID_USER49", value: 73 },
      { name: "MAV_COMP_ID_USER50", value: 74 },
      { name: "MAV_COMP_ID_USER51", value: 75 },
      { name: "MAV_COMP_ID_USER52", value: 76 },
      { name: "MAV_COMP_ID_USER53", value: 77 },
      { name: "MAV_COMP_ID_USER54", value: 78 },
      { name: "MAV_COMP_ID_USER55", value: 79 },
      { name: "MAV_COMP_ID_USER56", value: 80 },
      { name: "MAV_COMP_ID_USER57", value: 81 },
      { name: "MAV_COMP_ID_USER58", value: 82 },
      { name: "MAV_COMP_ID_USER59", value: 83 },
      { name: "MAV_COMP_ID_USER60", value: 84 },
      { name: "MAV_COMP_ID_USER61", value: 85 },
      { name: "MAV_COMP_ID_USER62", value: 86 },
      { name: "MAV_COMP_ID_USER63", value: 87 },
      { name: "MAV_COMP_ID_USER64", value: 88 },
      { name: "MAV_COMP_ID_USER65", value: 89 },
      { name: "MAV_COMP_ID_USER66", value: 90 },
      { name: "MAV_COMP_ID_USER67", value: 91 },
      { name: "MAV_COMP_ID_USER68", value: 92 },
      { name: "MAV_COMP_ID_USER69", value: 93 },
      { name: "MAV_COMP_ID_USER70", value: 94 },
      { name: "MAV_COMP_ID_USER71", value: 95 },
      { name: "MAV_COMP_ID_USER72", value: 96 },
      { name: "MAV_COMP_ID_USER73", value: 97 },
      { name: "MAV_COMP_ID_USER74", value: 98 },
      { name: "MAV_COMP_ID_USER75", value: 99 },
      { name: "MAV_COMP_ID_CAMERA", value: 100 },
      { name: "MAV_COMP_ID_CAMERA2", value: 101 },
      { name: "MAV_COMP_ID_CAMERA3", value: 102 },
      { name: "MAV_COMP_ID_CAMERA4", value: 103 },
      { name: "MAV_COMP_ID_CAMERA5", value: 104 },
      { name: "MAV_COMP_ID_CAMERA6", value: 105 },
      { name: "MAV_COMP_ID_RADIO", value: 110 },
      { name: "MAV_COMP_ID_RADIO2", value: 111 },
      { name: "MAV_COMP_ID_RADIO3", value: 112 },
      { name: "MAV_COMP_ID_SERVO1", value: 140 },
      { name: "MAV_COMP_ID_SERVO2", value: 141 },
      { name: "MAV_COMP_ID_SERVO3", value: 142 },
      { name: "MAV_COMP_ID_SERVO4", value: 143 },
      { name: "MAV_COMP_ID_SERVO5", value: 144 },
      { name: "MAV_COMP_ID_SERVO6", value: 145 },
      { name: "MAV_COMP_ID_SERVO7", value: 146 },
      { name: "MAV_COMP_ID_SERVO8", value: 147 },
      { name: "MAV_COMP_ID_SERVO9", value: 148 },
      { name: "MAV_COMP_ID_SERVO10", value: 149 },
      { name: "MAV_COMP_ID_SERVO11", value: 150 },
      { name: "MAV_COMP_ID_SERVO12", value: 151 },
      { name: "MAV_COMP_ID_SERVO13", value: 152 },
      { name: "MAV_COMP_ID_SERVO14", value: 153 },
      { name: "MAV_COMP_ID_GIMBAL", value: 154 },
      { name: "MAV_COMP_ID_LOG", value: 155 },
      { name: "MAV_COMP_ID_ADSB", value: 156 },
      { name: "MAV_COMP_ID_OSD", value: 157 },
      { name: "MAV_COMP_ID_PERIPHERAL", value: 158 },
      { name: "MAV_COMP_ID_QX1_GIMBAL", value: 159 },
      { name: "MAV_COMP_ID_FLARM", value: 160 },
      { name: "MAV_COMP_ID_PARACHUTE", value: 161 },
      { name: "MAV_COMP_ID_WINCH", value: 169 },
      { name: "MAV_COMP_ID_GIMBAL2", value: 171 },
      { name: "MAV_COMP_ID_GIMBAL3", value: 172 },
      { name: "MAV_COMP_ID_GIMBAL4", value: 173 },
      { name: "MAV_COMP_ID_GIMBAL5", value: 174 },
      { name: "MAV_COMP_ID_GIMBAL6", value: 175 },
      { name: "MAV_COMP_ID_BATTERY", value: 180 },
      { name: "MAV_COMP_ID_BATTERY2", value: 181 },
      { name: "MAV_COMP_ID_MAVCAN", value: 189 },
      { name: "MAV_COMP_ID_MISSIONPLANNER", value: 190 },
      { name: "MAV_COMP_ID_ONBOARD_COMPUTER", value: 191 },
      { name: "MAV_COMP_ID_ONBOARD_COMPUTER2", value: 192 },
      { name: "MAV_COMP_ID_ONBOARD_COMPUTER3", value: 193 },
      { name: "MAV_COMP_ID_ONBOARD_COMPUTER4", value: 194 },
      { name: "MAV_COMP_ID_PATHPLANNER", value: 195 },
      { name: "MAV_COMP_ID_OBSTACLE_AVOIDANCE", value: 196 },
      { name: "MAV_COMP_ID_VISUAL_INERTIAL_ODOMETRY", value: 197 },
      { name: "MAV_COMP_ID_PAIRING_MANAGER", value: 198 },
      { name: "MAV_COMP_ID_IMU", value: 200 },
      { name: "MAV_COMP_ID_IMU_2", value: 201 },
      { name: "MAV_COMP_ID_IMU_3", value: 202 },
      { name: "MAV_COMP_ID_GPS", value: 220 },
      { name: "MAV_COMP_ID_GPS2", value: 221 },
      { name: "MAV_COMP_ID_ODID_TXRX_1", value: 236 },
      { name: "MAV_COMP_ID_ODID_TXRX_2", value: 237 },
      { name: "MAV_COMP_ID_ODID_TXRX_3", value: 238 },
      { name: "MAV_COMP_ID_UDP_BRIDGE", value: 240 },
      { name: "MAV_COMP_ID_UART_BRIDGE", value: 241 },
      { name: "MAV_COMP_ID_TUNNEL_NODE", value: 242 },
      { name: "MAV_COMP_ID_ILLUMINATOR", value: 243 },
      { name: "MAV_COMP_ID_SYSTEM_CONTROL", value: 250 },
    ],
  },
  {
    name: "MAV_DATA_STREAM",
    isBitmask: false,
    entries: [
      { name: "MAV_DATA_STREAM_ALL", value: 0 },
      { name: "MAV_DATA_STREAM_RAW_SENSORS", value: 1 },
      { name: "MAV_DATA_STREAM_EXTENDED_STATUS", value: 2 },
      { name: "MAV_DATA_STREAM_RC_CHANNELS", value: 3 },
      { name: "MAV_DATA_STREAM_RAW_CONTROLLER", value: 4 },
      { name: "MAV_DATA_STREAM_POSITION", value: 6 },
      { name: "MAV_DATA_STREAM_EXTRA1", value: 10 },
      { name: "MAV_DATA_STREAM_EXTRA2", value: 11 },
      { name: "MAV_DATA_STREAM_EXTRA3", value: 12 },
    ],
  },
  {
    name: "MAV_DISTANCE_SENSOR",
    isBitmask: false,
    entries: [
      { name: "MAV_DISTANCE_SENSOR_LASER", value: 0 },
      { name: "MAV_DISTANCE_SENSOR_ULTRASOUND", value: 1 },
      { name: "MAV_DISTANCE_SENSOR_INFRARED", value: 2 },
      { name: "MAV_DISTANCE_SENSOR_RADAR", value: 3 },
      { name: "MAV_DISTANCE_SENSOR_UNKNOWN", value: 4 },
    ],
  },
  {
    name: "MAV_DO_REPOSITION_FLAGS",
    isBitmask: true,
    entries: [
      { name: "MAV_DO_REPOSITION_FLAGS_CHANGE_MODE", value: 1 },
      { name: "MAV_DO_REPOSITION_FLAGS_RELATIVE_YAW", value: 2 },
    ],
  },
  {
    name: "MAV_ESTIMATOR_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_ESTIMATOR_TYPE_UNKNOWN", value: 0 },
      { name: "MAV_ESTIMATOR_TYPE_NAIVE", value: 1 },
      { name: "MAV_ESTIMATOR_TYPE_VISION", value: 2 },
      { name: "MAV_ESTIMATOR_TYPE_VIO", value: 3 },
      { name: "MAV_ESTIMATOR_TYPE_GPS", value: 4 },
      { name: "MAV_ESTIMATOR_TYPE_GPS_INS", value: 5 },
      { name: "MAV_ESTIMATOR_TYPE_MOCAP", value: 6 },
      { name: "MAV_ESTIMATOR_TYPE_LIDAR", value: 7 },
      { name: "MAV_ESTIMATOR_TYPE_AUTOPILOT", value: 8 },
    ],
  },
  {
    name: "MAV_EVENT_CURRENT_SEQUENCE_FLAGS",
    isBitmask: true,
    entries: [
      { name: "MAV_EVENT_CURRENT_SEQUENCE_FLAGS_RESET", value: 1 },
    ],
  },
  {
    name: "MAV_EVENT_ERROR_REASON",
    isBitmask: false,
    entries: [
      { name: "MAV_EVENT_ERROR_REASON_UNAVAILABLE", value: 0 },
    ],
  },
  {
    name: "MAV_FRAME",
    isBitmask: false,
    entries: [
      { name: "MAV_FRAME_GLOBAL", value: 0 },
      { name: "MAV_FRAME_LOCAL_NED", value: 1 },
      { name: "MAV_FRAME_MISSION", value: 2 },
      { name: "MAV_FRAME_GLOBAL_RELATIVE_ALT", value: 3 },
      { name: "MAV_FRAME_LOCAL_ENU", value: 4 },
      { name: "MAV_FRAME_GLOBAL_INT", value: 5 },
      { name: "MAV_FRAME_GLOBAL_RELATIVE_ALT_INT", value: 6 },
      { name: "MAV_FRAME_LOCAL_OFFSET_NED", value: 7 },
      { name: "MAV_FRAME_BODY_NED", value: 8 },
      { name: "MAV_FRAME_BODY_OFFSET_NED", value: 9 },
      { name: "MAV_FRAME_GLOBAL_TERRAIN_ALT", value: 10 },
      { name: "MAV_FRAME_GLOBAL_TERRAIN_ALT_INT", value: 11 },
      { name: "MAV_FRAME_BODY_FRD", value: 12 },
      { name: "MAV_FRAME_RESERVED_13", value: 13 },
      { name: "MAV_FRAME_RESERVED_14", value: 14 },
      { name: "MAV_FRAME_RESERVED_15", value: 15 },
      { name: "MAV_FRAME_RESERVED_16", value: 16 },
      { name: "MAV_FRAME_RESERVED_17", value: 17 },
      { name: "MAV_FRAME_RESERVED_18", value: 18 },
      { name: "MAV_FRAME_RESERVED_19", value: 19 },
      { name: "MAV_FRAME_LOCAL_FRD", value: 20 },
      { name: "MAV_FRAME_LOCAL_FLU", value: 21 },
    ],
  },
  {
    name: "MAV_FTP_ERR",
    isBitmask: false,
    entries: [
      { name: "MAV_FTP_ERR_NONE", value: 0 },
      { name: "MAV_FTP_ERR_FAIL", value: 1 },
      { name: "MAV_FTP_ERR_FAILERRNO", value: 2 },
      { name: "MAV_FTP_ERR_INVALIDDATASIZE", value: 3 },
      { name: "MAV_FTP_ERR_INVALIDSESSION", value: 4 },
      { name: "MAV_FTP_ERR_NOSESSIONSAVAILABLE", value: 5 },
      { name: "MAV_FTP_ERR_EOF", value: 6 },
      { name: "MAV_FTP_ERR_UNKNOWNCOMMAND", value: 7 },
      { name: "MAV_FTP_ERR_FILEEXISTS", value: 8 },
      { name: "MAV_FTP_ERR_FILEPROTECTED", value: 9 },
      { name: "MAV_FTP_ERR_FILENOTFOUND", value: 10 },
    ],
  },
  {
    name: "MAV_FTP_OPCODE",
    isBitmask: false,
    entries: [
      { name: "MAV_FTP_OPCODE_NONE", value: 0 },
      { name: "MAV_FTP_OPCODE_TERMINATESESSION", value: 1 },
      { name: "MAV_FTP_OPCODE_RESETSESSION", value: 2 },
      { name: "MAV_FTP_OPCODE_LISTDIRECTORY", value: 3 },
      { name: "MAV_FTP_OPCODE_OPENFILERO", value: 4 },
      { name: "MAV_FTP_OPCODE_READFILE", value: 5 },
      { name: "MAV_FTP_OPCODE_CREATEFILE", value: 6 },
      { name: "MAV_FTP_OPCODE_WRITEFILE", value: 7 },
      { name: "MAV_FTP_OPCODE_REMOVEFILE", value: 8 },
      { name: "MAV_FTP_OPCODE_CREATEDIRECTORY", value: 9 },
      { name: "MAV_FTP_OPCODE_REMOVEDIRECTORY", value: 10 },
      { name: "MAV_FTP_OPCODE_OPENFILEWO", value: 11 },
      { name: "MAV_FTP_OPCODE_TRUNCATEFILE", value: 12 },
      { name: "MAV_FTP_OPCODE_RENAME", value: 13 },
      { name: "MAV_FTP_OPCODE_CALCFILECRC", value: 14 },
      { name: "MAV_FTP_OPCODE_BURSTREADFILE", value: 15 },
      { name: "MAV_FTP_OPCODE_LISTDIRECTORYWITHTIME", value: 16 },
      { name: "MAV_FTP_OPCODE_ACK", value: 128 },
      { name: "MAV_FTP_OPCODE_NAK", value: 129 },
    ],
  },
  {
    name: "MAV_FUEL_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_FUEL_TYPE_UNKNOWN", value: 0 },
      { name: "MAV_FUEL_TYPE_LIQUID", value: 1 },
      { name: "MAV_FUEL_TYPE_GAS", value: 2 },
    ],
  },
  {
    name: "MAV_GENERATOR_STATUS_FLAG",
    isBitmask: true,
    entries: [
      { name: "MAV_GENERATOR_STATUS_FLAG_OFF", value: 1 },
      { name: "MAV_GENERATOR_STATUS_FLAG_READY", value: 2 },
      { name: "MAV_GENERATOR_STATUS_FLAG_GENERATING", value: 4 },
      { name: "MAV_GENERATOR_STATUS_FLAG_CHARGING", value: 8 },
      { name: "MAV_GENERATOR_STATUS_FLAG_REDUCED_POWER", value: 16 },
      { name: "MAV_GENERATOR_STATUS_FLAG_MAXPOWER", value: 32 },
      { name: "MAV_GENERATOR_STATUS_FLAG_OVERTEMP_WARNING", value: 64 },
      { name: "MAV_GENERATOR_STATUS_FLAG_OVERTEMP_FAULT", value: 128 },
      { name: "MAV_GENERATOR_STATUS_FLAG_ELECTRONICS_OVERTEMP_WARNING", value: 256 },
      { name: "MAV_GENERATOR_STATUS_FLAG_ELECTRONICS_OVERTEMP_FAULT", value: 512 },
      { name: "MAV_GENERATOR_STATUS_FLAG_ELECTRONICS_FAULT", value: 1024 },
      { name: "MAV_GENERATOR_STATUS_FLAG_POWERSOURCE_FAULT", value: 2048 },
      { name: "MAV_GENERATOR_STATUS_FLAG_COMMUNICATION_WARNING", value: 4096 },
      { name: "MAV_GENERATOR_STATUS_FLAG_COOLING_WARNING", value: 8192 },
      { name: "MAV_GENERATOR_STATUS_FLAG_POWER_RAIL_FAULT", value: 16384 },
      { name: "MAV_GENERATOR_STATUS_FLAG_OVERCURRENT_FAULT", value: 32768 },
      { name: "MAV_GENERATOR_STATUS_FLAG_BATTERY_OVERCHARGE_CURRENT_FAULT", value: 65536 },
      { name: "MAV_GENERATOR_STATUS_FLAG_OVERVOLTAGE_FAULT", value: 131072 },
      { name: "MAV_GENERATOR_STATUS_FLAG_BATTERY_UNDERVOLT_FAULT", value: 262144 },
      { name: "MAV_GENERATOR_STATUS_FLAG_START_INHIBITED", value: 524288 },
      { name: "MAV_GENERATOR_STATUS_FLAG_MAINTENANCE_REQUIRED", value: 1048576 },
      { name: "MAV_GENERATOR_STATUS_FLAG_WARMING_UP", value: 2097152 },
      { name: "MAV_GENERATOR_STATUS_FLAG_IDLE", value: 4194304 },
    ],
  },
  {
    name: "MAV_GOTO",
    isBitmask: false,
    entries: [
      { name: "MAV_GOTO_DO_HOLD", value: 0 },
      { name: "MAV_GOTO_DO_CONTINUE", value: 1 },
      { name: "MAV_GOTO_HOLD_AT_CURRENT_POSITION", value: 2 },
      { name: "MAV_GOTO_HOLD_AT_SPECIFIED_POSITION", value: 3 },
    ],
  },
  {
    name: "MAV_LANDED_STATE",
    isBitmask: false,
    entries: [
      { name: "MAV_LANDED_STATE_UNDEFINED", value: 0 },
      { name: "MAV_LANDED_STATE_ON_GROUND", value: 1 },
      { name: "MAV_LANDED_STATE_IN_AIR", value: 2 },
      { name: "MAV_LANDED_STATE_TAKEOFF", value: 3 },
      { name: "MAV_LANDED_STATE_LANDING", value: 4 },
    ],
  },
  {
    name: "MAV_MISSION_RESULT",
    isBitmask: false,
    entries: [
      { name: "MAV_MISSION_ACCEPTED", value: 0 },
      { name: "MAV_MISSION_ERROR", value: 1 },
      { name: "MAV_MISSION_UNSUPPORTED_FRAME", value: 2 },
      { name: "MAV_MISSION_UNSUPPORTED", value: 3 },
      { name: "MAV_MISSION_NO_SPACE", value: 4 },
      { name: "MAV_MISSION_INVALID", value: 5 },
      { name: "MAV_MISSION_INVALID_PARAM1", value: 6 },
      { name: "MAV_MISSION_INVALID_PARAM2", value: 7 },
      { name: "MAV_MISSION_INVALID_PARAM3", value: 8 },
      { name: "MAV_MISSION_INVALID_PARAM4", value: 9 },
      { name: "MAV_MISSION_INVALID_PARAM5_X", value: 10 },
      { name: "MAV_MISSION_INVALID_PARAM6_Y", value: 11 },
      { name: "MAV_MISSION_INVALID_PARAM7", value: 12 },
      { name: "MAV_MISSION_INVALID_SEQUENCE", value: 13 },
      { name: "MAV_MISSION_DENIED", value: 14 },
      { name: "MAV_MISSION_OPERATION_CANCELLED", value: 15 },
    ],
  },
  {
    name: "MAV_MISSION_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_MISSION_TYPE_MISSION", value: 0 },
      { name: "MAV_MISSION_TYPE_FENCE", value: 1 },
      { name: "MAV_MISSION_TYPE_RALLY", value: 2 },
      { name: "MAV_MISSION_TYPE_ALL", value: 255 },
    ],
  },
  {
    name: "MAV_MODE",
    isBitmask: false,
    entries: [
      { name: "MAV_MODE_PREFLIGHT", value: 0 },
      { name: "MAV_MODE_MANUAL_DISARMED", value: 64 },
      { name: "MAV_MODE_TEST_DISARMED", value: 66 },
      { name: "MAV_MODE_STABILIZE_DISARMED", value: 80 },
      { name: "MAV_MODE_GUIDED_DISARMED", value: 88 },
      { name: "MAV_MODE_AUTO_DISARMED", value: 92 },
      { name: "MAV_MODE_MANUAL_ARMED", value: 192 },
      { name: "MAV_MODE_TEST_ARMED", value: 194 },
      { name: "MAV_MODE_STABILIZE_ARMED", value: 208 },
      { name: "MAV_MODE_GUIDED_ARMED", value: 216 },
      { name: "MAV_MODE_AUTO_ARMED", value: 220 },
    ],
  },
  {
    name: "MAV_MODE_FLAG",
    isBitmask: true,
    entries: [
      { name: "MAV_MODE_FLAG_CUSTOM_MODE_ENABLED", value: 1 },
      { name: "MAV_MODE_FLAG_TEST_ENABLED", value: 2 },
      { name: "MAV_MODE_FLAG_AUTO_ENABLED", value: 4 },
      { name: "MAV_MODE_FLAG_GUIDED_ENABLED", value: 8 },
      { name: "MAV_MODE_FLAG_STABILIZE_ENABLED", value: 16 },
      { name: "MAV_MODE_FLAG_HIL_ENABLED", value: 32 },
      { name: "MAV_MODE_FLAG_MANUAL_INPUT_ENABLED", value: 64 },
      { name: "MAV_MODE_FLAG_SAFETY_ARMED", value: 128 },
    ],
  },
  {
    name: "MAV_MODE_FLAG_DECODE_POSITION",
    isBitmask: true,
    entries: [
      { name: "MAV_MODE_FLAG_DECODE_POSITION_CUSTOM_MODE", value: 1 },
      { name: "MAV_MODE_FLAG_DECODE_POSITION_TEST", value: 2 },
      { name: "MAV_MODE_FLAG_DECODE_POSITION_AUTO", value: 4 },
      { name: "MAV_MODE_FLAG_DECODE_POSITION_GUIDED", value: 8 },
      { name: "MAV_MODE_FLAG_DECODE_POSITION_STABILIZE", value: 16 },
      { name: "MAV_MODE_FLAG_DECODE_POSITION_HIL", value: 32 },
      { name: "MAV_MODE_FLAG_DECODE_POSITION_MANUAL", value: 64 },
      { name: "MAV_MODE_FLAG_DECODE_POSITION_SAFETY", value: 128 },
    ],
  },
  {
    name: "MAV_MODE_GIMBAL",
    isBitmask: false,
    entries: [
      { name: "MAV_MODE_GIMBAL_UNINITIALIZED", value: 0 },
      { name: "MAV_MODE_GIMBAL_CALIBRATING_PITCH", value: 1 },
      { name: "MAV_MODE_GIMBAL_CALIBRATING_ROLL", value: 2 },
      { name: "MAV_MODE_GIMBAL_CALIBRATING_YAW", value: 3 },
      { name: "MAV_MODE_GIMBAL_INITIALIZED", value: 4 },
      { name: "MAV_MODE_GIMBAL_ACTIVE", value: 5 },
      { name: "MAV_MODE_GIMBAL_RATE_CMD_TIMEOUT", value: 6 },
    ],
  },
  {
    name: "MAV_MODE_PROPERTY",
    isBitmask: true,
    entries: [
      { name: "MAV_MODE_PROPERTY_ADVANCED", value: 1 },
      { name: "MAV_MODE_PROPERTY_NOT_USER_SELECTABLE", value: 2 },
      { name: "MAV_MODE_PROPERTY_AUTO_MODE", value: 4 },
    ],
  },
  {
    name: "MAV_MOUNT_MODE",
    isBitmask: false,
    entries: [
      { name: "MAV_MOUNT_MODE_RETRACT", value: 0 },
      { name: "MAV_MOUNT_MODE_NEUTRAL", value: 1 },
      { name: "MAV_MOUNT_MODE_MAVLINK_TARGETING", value: 2 },
      { name: "MAV_MOUNT_MODE_RC_TARGETING", value: 3 },
      { name: "MAV_MOUNT_MODE_GPS_POINT", value: 4 },
      { name: "MAV_MOUNT_MODE_SYSID_TARGET", value: 5 },
      { name: "MAV_MOUNT_MODE_HOME_LOCATION", value: 6 },
      { name: "MAV_MOUNT_MODE_WPNEXT_OFFSET", value: 7 },
    ],
  },
  {
    name: "MAV_ODID_ARM_STATUS",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_ARM_STATUS_GOOD_TO_ARM", value: 0 },
      { name: "MAV_ODID_ARM_STATUS_PRE_ARM_FAIL_GENERIC", value: 1 },
    ],
  },
  {
    name: "MAV_ODID_AUTH_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_AUTH_TYPE_NONE", value: 0 },
      { name: "MAV_ODID_AUTH_TYPE_UAS_ID_SIGNATURE", value: 1 },
      { name: "MAV_ODID_AUTH_TYPE_OPERATOR_ID_SIGNATURE", value: 2 },
      { name: "MAV_ODID_AUTH_TYPE_MESSAGE_SET_SIGNATURE", value: 3 },
      { name: "MAV_ODID_AUTH_TYPE_NETWORK_REMOTE_ID", value: 4 },
      { name: "MAV_ODID_AUTH_TYPE_SPECIFIC_AUTHENTICATION", value: 5 },
    ],
  },
  {
    name: "MAV_ODID_CATEGORY_EU",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_CATEGORY_EU_UNDECLARED", value: 0 },
      { name: "MAV_ODID_CATEGORY_EU_OPEN", value: 1 },
      { name: "MAV_ODID_CATEGORY_EU_SPECIFIC", value: 2 },
      { name: "MAV_ODID_CATEGORY_EU_CERTIFIED", value: 3 },
    ],
  },
  {
    name: "MAV_ODID_CLASS_EU",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_CLASS_EU_UNDECLARED", value: 0 },
      { name: "MAV_ODID_CLASS_EU_CLASS_0", value: 1 },
      { name: "MAV_ODID_CLASS_EU_CLASS_1", value: 2 },
      { name: "MAV_ODID_CLASS_EU_CLASS_2", value: 3 },
      { name: "MAV_ODID_CLASS_EU_CLASS_3", value: 4 },
      { name: "MAV_ODID_CLASS_EU_CLASS_4", value: 5 },
      { name: "MAV_ODID_CLASS_EU_CLASS_5", value: 6 },
      { name: "MAV_ODID_CLASS_EU_CLASS_6", value: 7 },
    ],
  },
  {
    name: "MAV_ODID_CLASSIFICATION_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_CLASSIFICATION_TYPE_UNDECLARED", value: 0 },
      { name: "MAV_ODID_CLASSIFICATION_TYPE_EU", value: 1 },
    ],
  },
  {
    name: "MAV_ODID_DESC_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_DESC_TYPE_TEXT", value: 0 },
      { name: "MAV_ODID_DESC_TYPE_EMERGENCY", value: 1 },
      { name: "MAV_ODID_DESC_TYPE_EXTENDED_STATUS", value: 2 },
    ],
  },
  {
    name: "MAV_ODID_HEIGHT_REF",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_HEIGHT_REF_OVER_TAKEOFF", value: 0 },
      { name: "MAV_ODID_HEIGHT_REF_OVER_GROUND", value: 1 },
    ],
  },
  {
    name: "MAV_ODID_HOR_ACC",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_HOR_ACC_UNKNOWN", value: 0 },
      { name: "MAV_ODID_HOR_ACC_10NM", value: 1 },
      { name: "MAV_ODID_HOR_ACC_4NM", value: 2 },
      { name: "MAV_ODID_HOR_ACC_2NM", value: 3 },
      { name: "MAV_ODID_HOR_ACC_1NM", value: 4 },
      { name: "MAV_ODID_HOR_ACC_0_5NM", value: 5 },
      { name: "MAV_ODID_HOR_ACC_0_3NM", value: 6 },
      { name: "MAV_ODID_HOR_ACC_0_1NM", value: 7 },
      { name: "MAV_ODID_HOR_ACC_0_05NM", value: 8 },
      { name: "MAV_ODID_HOR_ACC_30_METER", value: 9 },
      { name: "MAV_ODID_HOR_ACC_10_METER", value: 10 },
      { name: "MAV_ODID_HOR_ACC_3_METER", value: 11 },
      { name: "MAV_ODID_HOR_ACC_1_METER", value: 12 },
    ],
  },
  {
    name: "MAV_ODID_ID_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_ID_TYPE_NONE", value: 0 },
      { name: "MAV_ODID_ID_TYPE_SERIAL_NUMBER", value: 1 },
      { name: "MAV_ODID_ID_TYPE_CAA_REGISTRATION_ID", value: 2 },
      { name: "MAV_ODID_ID_TYPE_UTM_ASSIGNED_UUID", value: 3 },
      { name: "MAV_ODID_ID_TYPE_SPECIFIC_SESSION_ID", value: 4 },
    ],
  },
  {
    name: "MAV_ODID_OPERATOR_ID_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_OPERATOR_ID_TYPE_CAA", value: 0 },
    ],
  },
  {
    name: "MAV_ODID_OPERATOR_LOCATION_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_OPERATOR_LOCATION_TYPE_TAKEOFF", value: 0 },
      { name: "MAV_ODID_OPERATOR_LOCATION_TYPE_LIVE_GNSS", value: 1 },
      { name: "MAV_ODID_OPERATOR_LOCATION_TYPE_FIXED", value: 2 },
    ],
  },
  {
    name: "MAV_ODID_SPEED_ACC",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_SPEED_ACC_UNKNOWN", value: 0 },
      { name: "MAV_ODID_SPEED_ACC_10_METERS_PER_SECOND", value: 1 },
      { name: "MAV_ODID_SPEED_ACC_3_METERS_PER_SECOND", value: 2 },
      { name: "MAV_ODID_SPEED_ACC_1_METERS_PER_SECOND", value: 3 },
      { name: "MAV_ODID_SPEED_ACC_0_3_METERS_PER_SECOND", value: 4 },
    ],
  },
  {
    name: "MAV_ODID_STATUS",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_STATUS_UNDECLARED", value: 0 },
      { name: "MAV_ODID_STATUS_GROUND", value: 1 },
      { name: "MAV_ODID_STATUS_AIRBORNE", value: 2 },
      { name: "MAV_ODID_STATUS_EMERGENCY", value: 3 },
      { name: "MAV_ODID_STATUS_REMOTE_ID_SYSTEM_FAILURE", value: 4 },
    ],
  },
  {
    name: "MAV_ODID_TIME_ACC",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_TIME_ACC_UNKNOWN", value: 0 },
      { name: "MAV_ODID_TIME_ACC_0_1_SECOND", value: 1 },
      { name: "MAV_ODID_TIME_ACC_0_2_SECOND", value: 2 },
      { name: "MAV_ODID_TIME_ACC_0_3_SECOND", value: 3 },
      { name: "MAV_ODID_TIME_ACC_0_4_SECOND", value: 4 },
      { name: "MAV_ODID_TIME_ACC_0_5_SECOND", value: 5 },
      { name: "MAV_ODID_TIME_ACC_0_6_SECOND", value: 6 },
      { name: "MAV_ODID_TIME_ACC_0_7_SECOND", value: 7 },
      { name: "MAV_ODID_TIME_ACC_0_8_SECOND", value: 8 },
      { name: "MAV_ODID_TIME_ACC_0_9_SECOND", value: 9 },
      { name: "MAV_ODID_TIME_ACC_1_0_SECOND", value: 10 },
      { name: "MAV_ODID_TIME_ACC_1_1_SECOND", value: 11 },
      { name: "MAV_ODID_TIME_ACC_1_2_SECOND", value: 12 },
      { name: "MAV_ODID_TIME_ACC_1_3_SECOND", value: 13 },
      { name: "MAV_ODID_TIME_ACC_1_4_SECOND", value: 14 },
      { name: "MAV_ODID_TIME_ACC_1_5_SECOND", value: 15 },
    ],
  },
  {
    name: "MAV_ODID_UA_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_UA_TYPE_NONE", value: 0 },
      { name: "MAV_ODID_UA_TYPE_AEROPLANE", value: 1 },
      { name: "MAV_ODID_UA_TYPE_HELICOPTER_OR_MULTIROTOR", value: 2 },
      { name: "MAV_ODID_UA_TYPE_GYROPLANE", value: 3 },
      { name: "MAV_ODID_UA_TYPE_HYBRID_LIFT", value: 4 },
      { name: "MAV_ODID_UA_TYPE_ORNITHOPTER", value: 5 },
      { name: "MAV_ODID_UA_TYPE_GLIDER", value: 6 },
      { name: "MAV_ODID_UA_TYPE_KITE", value: 7 },
      { name: "MAV_ODID_UA_TYPE_FREE_BALLOON", value: 8 },
      { name: "MAV_ODID_UA_TYPE_CAPTIVE_BALLOON", value: 9 },
      { name: "MAV_ODID_UA_TYPE_AIRSHIP", value: 10 },
      { name: "MAV_ODID_UA_TYPE_FREE_FALL_PARACHUTE", value: 11 },
      { name: "MAV_ODID_UA_TYPE_ROCKET", value: 12 },
      { name: "MAV_ODID_UA_TYPE_TETHERED_POWERED_AIRCRAFT", value: 13 },
      { name: "MAV_ODID_UA_TYPE_GROUND_OBSTACLE", value: 14 },
      { name: "MAV_ODID_UA_TYPE_OTHER", value: 15 },
    ],
  },
  {
    name: "MAV_ODID_VER_ACC",
    isBitmask: false,
    entries: [
      { name: "MAV_ODID_VER_ACC_UNKNOWN", value: 0 },
      { name: "MAV_ODID_VER_ACC_150_METER", value: 1 },
      { name: "MAV_ODID_VER_ACC_45_METER", value: 2 },
      { name: "MAV_ODID_VER_ACC_25_METER", value: 3 },
      { name: "MAV_ODID_VER_ACC_10_METER", value: 4 },
      { name: "MAV_ODID_VER_ACC_3_METER", value: 5 },
      { name: "MAV_ODID_VER_ACC_1_METER", value: 6 },
    ],
  },
  {
    name: "MAV_PARAM_ERROR",
    isBitmask: false,
    entries: [
      { name: "MAV_PARAM_ERROR_NO_ERROR", value: 0 },
      { name: "MAV_PARAM_ERROR_DOES_NOT_EXIST", value: 1 },
      { name: "MAV_PARAM_ERROR_VALUE_OUT_OF_RANGE", value: 2 },
      { name: "MAV_PARAM_ERROR_PERMISSION_DENIED", value: 3 },
      { name: "MAV_PARAM_ERROR_COMPONENT_NOT_FOUND", value: 4 },
      { name: "MAV_PARAM_ERROR_READ_ONLY", value: 5 },
      { name: "MAV_PARAM_ERROR_TYPE_UNSUPPORTED", value: 6 },
      { name: "MAV_PARAM_ERROR_TYPE_MISMATCH", value: 7 },
      { name: "MAV_PARAM_ERROR_READ_FAIL", value: 8 },
    ],
  },
  {
    name: "MAV_PARAM_EXT_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_PARAM_EXT_TYPE_UINT8", value: 1 },
      { name: "MAV_PARAM_EXT_TYPE_INT8", value: 2 },
      { name: "MAV_PARAM_EXT_TYPE_UINT16", value: 3 },
      { name: "MAV_PARAM_EXT_TYPE_INT16", value: 4 },
      { name: "MAV_PARAM_EXT_TYPE_UINT32", value: 5 },
      { name: "MAV_PARAM_EXT_TYPE_INT32", value: 6 },
      { name: "MAV_PARAM_EXT_TYPE_UINT64", value: 7 },
      { name: "MAV_PARAM_EXT_TYPE_INT64", value: 8 },
      { name: "MAV_PARAM_EXT_TYPE_REAL32", value: 9 },
      { name: "MAV_PARAM_EXT_TYPE_REAL64", value: 10 },
      { name: "MAV_PARAM_EXT_TYPE_CUSTOM", value: 11 },
    ],
  },
  {
    name: "MAV_PARAM_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_PARAM_TYPE_UINT8", value: 1 },
      { name: "MAV_PARAM_TYPE_INT8", value: 2 },
      { name: "MAV_PARAM_TYPE_UINT16", value: 3 },
      { name: "MAV_PARAM_TYPE_INT16", value: 4 },
      { name: "MAV_PARAM_TYPE_UINT32", value: 5 },
      { name: "MAV_PARAM_TYPE_INT32", value: 6 },
      { name: "MAV_PARAM_TYPE_UINT64", value: 7 },
      { name: "MAV_PARAM_TYPE_INT64", value: 8 },
      { name: "MAV_PARAM_TYPE_REAL32", value: 9 },
      { name: "MAV_PARAM_TYPE_REAL64", value: 10 },
    ],
  },
  {
    name: "MAV_POWER_STATUS",
    isBitmask: true,
    entries: [
      { name: "MAV_POWER_STATUS_BRICK_VALID", value: 1 },
      { name: "MAV_POWER_STATUS_SERVO_VALID", value: 2 },
      { name: "MAV_POWER_STATUS_USB_CONNECTED", value: 4 },
      { name: "MAV_POWER_STATUS_PERIPH_OVERCURRENT", value: 8 },
      { name: "MAV_POWER_STATUS_PERIPH_HIPOWER_OVERCURRENT", value: 16 },
      { name: "MAV_POWER_STATUS_CHANGED", value: 32 },
    ],
  },
  {
    name: "MAV_PROTOCOL_CAPABILITY",
    isBitmask: true,
    entries: [
      { name: "MAV_PROTOCOL_CAPABILITY_MISSION_FLOAT", value: 1 },
      { name: "MAV_PROTOCOL_CAPABILITY_PARAM_FLOAT", value: 2 },
      { name: "MAV_PROTOCOL_CAPABILITY_MISSION_INT", value: 4 },
      { name: "MAV_PROTOCOL_CAPABILITY_COMMAND_INT", value: 8 },
      { name: "MAV_PROTOCOL_CAPABILITY_PARAM_ENCODE_BYTEWISE", value: 16 },
      { name: "MAV_PROTOCOL_CAPABILITY_FTP", value: 32 },
      { name: "MAV_PROTOCOL_CAPABILITY_SET_ATTITUDE_TARGET", value: 64 },
      { name: "MAV_PROTOCOL_CAPABILITY_SET_POSITION_TARGET_LOCAL_NED", value: 128 },
      { name: "MAV_PROTOCOL_CAPABILITY_SET_POSITION_TARGET_GLOBAL_INT", value: 256 },
      { name: "MAV_PROTOCOL_CAPABILITY_TERRAIN", value: 512 },
      { name: "MAV_PROTOCOL_CAPABILITY_RESERVED3", value: 1024 },
      { name: "MAV_PROTOCOL_CAPABILITY_FLIGHT_TERMINATION", value: 2048 },
      { name: "MAV_PROTOCOL_CAPABILITY_COMPASS_CALIBRATION", value: 4096 },
      { name: "MAV_PROTOCOL_CAPABILITY_MAVLINK2", value: 8192 },
      { name: "MAV_PROTOCOL_CAPABILITY_MISSION_FENCE", value: 16384 },
      { name: "MAV_PROTOCOL_CAPABILITY_MISSION_RALLY", value: 32768 },
      { name: "MAV_PROTOCOL_CAPABILITY_RESERVED2", value: 65536 },
      { name: "MAV_PROTOCOL_CAPABILITY_PARAM_ENCODE_C_CAST", value: 131072 },
      { name: "MAV_PROTOCOL_CAPABILITY_COMPONENT_IMPLEMENTS_GIMBAL_MANAGER", value: 262144 },
      { name: "MAV_PROTOCOL_CAPABILITY_COMPONENT_ACCEPTS_GCS_CONTROL", value: 524288 },
      { name: "MAV_PROTOCOL_CAPABILITY_GRIPPER", value: 1048576 },
    ],
  },
  {
    name: "MAV_REMOTE_LOG_DATA_BLOCK_COMMANDS",
    isBitmask: false,
    entries: [
      { name: "MAV_REMOTE_LOG_DATA_BLOCK_STOP", value: 2147483645 },
      { name: "MAV_REMOTE_LOG_DATA_BLOCK_START", value: 2147483646 },
    ],
  },
  {
    name: "MAV_REMOTE_LOG_DATA_BLOCK_STATUSES",
    isBitmask: false,
    entries: [
      { name: "MAV_REMOTE_LOG_DATA_BLOCK_NACK", value: 0 },
      { name: "MAV_REMOTE_LOG_DATA_BLOCK_ACK", value: 1 },
    ],
  },
  {
    name: "MAV_RESULT",
    isBitmask: false,
    entries: [
      { name: "MAV_RESULT_ACCEPTED", value: 0 },
      { name: "MAV_RESULT_TEMPORARILY_REJECTED", value: 1 },
      { name: "MAV_RESULT_DENIED", value: 2 },
      { name: "MAV_RESULT_UNSUPPORTED", value: 3 },
      { name: "MAV_RESULT_FAILED", value: 4 },
      { name: "MAV_RESULT_IN_PROGRESS", value: 5 },
      { name: "MAV_RESULT_CANCELLED", value: 6 },
      { name: "MAV_RESULT_COMMAND_LONG_ONLY", value: 7 },
      { name: "MAV_RESULT_COMMAND_INT_ONLY", value: 8 },
      { name: "MAV_RESULT_COMMAND_UNSUPPORTED_MAV_FRAME", value: 9 },
      { name: "MAV_RESULT_NOT_IN_CONTROL", value: 10 },
    ],
  },
  {
    name: "MAV_ROI",
    isBitmask: false,
    entries: [
      { name: "MAV_ROI_NONE", value: 0 },
      { name: "MAV_ROI_WPNEXT", value: 1 },
      { name: "MAV_ROI_WPINDEX", value: 2 },
      { name: "MAV_ROI_LOCATION", value: 3 },
      { name: "MAV_ROI_TARGET", value: 4 },
    ],
  },
  {
    name: "MAV_SENSOR_ORIENTATION",
    isBitmask: false,
    entries: [
      { name: "MAV_SENSOR_ROTATION_NONE", value: 0 },
      { name: "MAV_SENSOR_ROTATION_YAW_45", value: 1 },
      { name: "MAV_SENSOR_ROTATION_YAW_90", value: 2 },
      { name: "MAV_SENSOR_ROTATION_YAW_135", value: 3 },
      { name: "MAV_SENSOR_ROTATION_YAW_180", value: 4 },
      { name: "MAV_SENSOR_ROTATION_YAW_225", value: 5 },
      { name: "MAV_SENSOR_ROTATION_YAW_270", value: 6 },
      { name: "MAV_SENSOR_ROTATION_YAW_315", value: 7 },
      { name: "MAV_SENSOR_ROTATION_ROLL_180", value: 8 },
      { name: "MAV_SENSOR_ROTATION_ROLL_180_YAW_45", value: 9 },
      { name: "MAV_SENSOR_ROTATION_ROLL_180_YAW_90", value: 10 },
      { name: "MAV_SENSOR_ROTATION_ROLL_180_YAW_135", value: 11 },
      { name: "MAV_SENSOR_ROTATION_PITCH_180", value: 12 },
      { name: "MAV_SENSOR_ROTATION_ROLL_180_YAW_225", value: 13 },
      { name: "MAV_SENSOR_ROTATION_ROLL_180_YAW_270", value: 14 },
      { name: "MAV_SENSOR_ROTATION_ROLL_180_YAW_315", value: 15 },
      { name: "MAV_SENSOR_ROTATION_ROLL_90", value: 16 },
      { name: "MAV_SENSOR_ROTATION_ROLL_90_YAW_45", value: 17 },
      { name: "MAV_SENSOR_ROTATION_ROLL_90_YAW_90", value: 18 },
      { name: "MAV_SENSOR_ROTATION_ROLL_90_YAW_135", value: 19 },
      { name: "MAV_SENSOR_ROTATION_ROLL_270", value: 20 },
      { name: "MAV_SENSOR_ROTATION_ROLL_270_YAW_45", value: 21 },
      { name: "MAV_SENSOR_ROTATION_ROLL_270_YAW_90", value: 22 },
      { name: "MAV_SENSOR_ROTATION_ROLL_270_YAW_135", value: 23 },
      { name: "MAV_SENSOR_ROTATION_PITCH_90", value: 24 },
      { name: "MAV_SENSOR_ROTATION_PITCH_270", value: 25 },
      { name: "MAV_SENSOR_ROTATION_PITCH_180_YAW_90", value: 26 },
      { name: "MAV_SENSOR_ROTATION_PITCH_180_YAW_270", value: 27 },
      { name: "MAV_SENSOR_ROTATION_ROLL_90_PITCH_90", value: 28 },
      { name: "MAV_SENSOR_ROTATION_ROLL_180_PITCH_90", value: 29 },
      { name: "MAV_SENSOR_ROTATION_ROLL_270_PITCH_90", value: 30 },
      { name: "MAV_SENSOR_ROTATION_ROLL_90_PITCH_180", value: 31 },
      { name: "MAV_SENSOR_ROTATION_ROLL_270_PITCH_180", value: 32 },
      { name: "MAV_SENSOR_ROTATION_ROLL_90_PITCH_270", value: 33 },
      { name: "MAV_SENSOR_ROTATION_ROLL_180_PITCH_270", value: 34 },
      { name: "MAV_SENSOR_ROTATION_ROLL_270_PITCH_270", value: 35 },
      { name: "MAV_SENSOR_ROTATION_ROLL_90_PITCH_180_YAW_90", value: 36 },
      { name: "MAV_SENSOR_ROTATION_ROLL_90_YAW_270", value: 37 },
      { name: "MAV_SENSOR_ROTATION_ROLL_90_PITCH_68_YAW_293", value: 38 },
      { name: "MAV_SENSOR_ROTATION_PITCH_315", value: 39 },
      { name: "MAV_SENSOR_ROTATION_ROLL_90_PITCH_315", value: 40 },
      { name: "MAV_SENSOR_ROTATION_CUSTOM", value: 100 },
    ],
  },
  {
    name: "MAV_SEVERITY",
    isBitmask: false,
    entries: [
      { name: "MAV_SEVERITY_EMERGENCY", value: 0 },
      { name: "MAV_SEVERITY_ALERT", value: 1 },
      { name: "MAV_SEVERITY_CRITICAL", value: 2 },
      { name: "MAV_SEVERITY_ERROR", value: 3 },
      { name: "MAV_SEVERITY_WARNING", value: 4 },
      { name: "MAV_SEVERITY_NOTICE", value: 5 },
      { name: "MAV_SEVERITY_INFO", value: 6 },
      { name: "MAV_SEVERITY_DEBUG", value: 7 },
    ],
  },
  {
    name: "MAV_STANDARD_MODE",
    isBitmask: false,
    entries: [
      { name: "MAV_STANDARD_MODE_NON_STANDARD", value: 0 },
      { name: "MAV_STANDARD_MODE_POSITION_HOLD", value: 1 },
      { name: "MAV_STANDARD_MODE_ORBIT", value: 2 },
      { name: "MAV_STANDARD_MODE_CRUISE", value: 3 },
      { name: "MAV_STANDARD_MODE_ALTITUDE_HOLD", value: 4 },
      { name: "MAV_STANDARD_MODE_SAFE_RECOVERY", value: 5 },
      { name: "MAV_STANDARD_MODE_MISSION", value: 6 },
      { name: "MAV_STANDARD_MODE_LAND", value: 7 },
      { name: "MAV_STANDARD_MODE_TAKEOFF", value: 8 },
    ],
  },
  {
    name: "MAV_STATE",
    isBitmask: false,
    entries: [
      { name: "MAV_STATE_UNINIT", value: 0 },
      { name: "MAV_STATE_BOOT", value: 1 },
      { name: "MAV_STATE_CALIBRATING", value: 2 },
      { name: "MAV_STATE_STANDBY", value: 3 },
      { name: "MAV_STATE_ACTIVE", value: 4 },
      { name: "MAV_STATE_CRITICAL", value: 5 },
      { name: "MAV_STATE_EMERGENCY", value: 6 },
      { name: "MAV_STATE_POWEROFF", value: 7 },
      { name: "MAV_STATE_FLIGHT_TERMINATION", value: 8 },
    ],
  },
  {
    name: "MAV_SYS_STATUS_SENSOR",
    isBitmask: true,
    entries: [
      { name: "MAV_SYS_STATUS_SENSOR_3D_GYRO", value: 1 },
      { name: "MAV_SYS_STATUS_SENSOR_3D_ACCEL", value: 2 },
      { name: "MAV_SYS_STATUS_SENSOR_3D_MAG", value: 4 },
      { name: "MAV_SYS_STATUS_SENSOR_ABSOLUTE_PRESSURE", value: 8 },
      { name: "MAV_SYS_STATUS_SENSOR_DIFFERENTIAL_PRESSURE", value: 16 },
      { name: "MAV_SYS_STATUS_SENSOR_GPS", value: 32 },
      { name: "MAV_SYS_STATUS_SENSOR_OPTICAL_FLOW", value: 64 },
      { name: "MAV_SYS_STATUS_SENSOR_VISION_POSITION", value: 128 },
      { name: "MAV_SYS_STATUS_SENSOR_LASER_POSITION", value: 256 },
      { name: "MAV_SYS_STATUS_SENSOR_EXTERNAL_GROUND_TRUTH", value: 512 },
      { name: "MAV_SYS_STATUS_SENSOR_ANGULAR_RATE_CONTROL", value: 1024 },
      { name: "MAV_SYS_STATUS_SENSOR_ATTITUDE_STABILIZATION", value: 2048 },
      { name: "MAV_SYS_STATUS_SENSOR_YAW_POSITION", value: 4096 },
      { name: "MAV_SYS_STATUS_SENSOR_Z_ALTITUDE_CONTROL", value: 8192 },
      { name: "MAV_SYS_STATUS_SENSOR_XY_POSITION_CONTROL", value: 16384 },
      { name: "MAV_SYS_STATUS_SENSOR_MOTOR_OUTPUTS", value: 32768 },
      { name: "MAV_SYS_STATUS_SENSOR_RC_RECEIVER", value: 65536 },
      { name: "MAV_SYS_STATUS_SENSOR_3D_GYRO2", value: 131072 },
      { name: "MAV_SYS_STATUS_SENSOR_3D_ACCEL2", value: 262144 },
      { name: "MAV_SYS_STATUS_SENSOR_3D_MAG2", value: 524288 },
      { name: "MAV_SYS_STATUS_GEOFENCE", value: 1048576 },
      { name: "MAV_SYS_STATUS_AHRS", value: 2097152 },
      { name: "MAV_SYS_STATUS_TERRAIN", value: 4194304 },
      { name: "MAV_SYS_STATUS_REVERSE_MOTOR", value: 8388608 },
      { name: "MAV_SYS_STATUS_LOGGING", value: 16777216 },
      { name: "MAV_SYS_STATUS_SENSOR_BATTERY", value: 33554432 },
      { name: "MAV_SYS_STATUS_SENSOR_PROXIMITY", value: 67108864 },
      { name: "MAV_SYS_STATUS_SENSOR_SATCOM", value: 134217728 },
      { name: "MAV_SYS_STATUS_PREARM_CHECK", value: 268435456 },
      { name: "MAV_SYS_STATUS_OBSTACLE_AVOIDANCE", value: 536870912 },
      { name: "MAV_SYS_STATUS_SENSOR_PROPULSION", value: 1073741824 },
      { name: "MAV_SYS_STATUS_EXTENSION_USED", value: 2147483648 },
    ],
  },
  {
    name: "MAV_SYS_STATUS_SENSOR_EXTENDED",
    isBitmask: true,
    entries: [
      { name: "MAV_SYS_STATUS_RECOVERY_SYSTEM", value: 1 },
      { name: "MAV_SYS_STATUS_SENSOR_LEAK", value: 2 },
      { name: "MAV_SYS_STATUS_SENSOR_3D_GYRO3", value: 4 },
      { name: "MAV_SYS_STATUS_SENSOR_3D_ACCEL3", value: 8 },
      { name: "MAV_SYS_STATUS_SENSOR_3D_GYRO4", value: 16 },
      { name: "MAV_SYS_STATUS_SENSOR_3D_ACCEL4", value: 32 },
      { name: "MAV_SYS_STATUS_SENSOR_3D_MAG3", value: 64 },
      { name: "MAV_SYS_STATUS_SENSOR_3D_MAG4", value: 128 },
    ],
  },
  {
    name: "MAV_TUNNEL_PAYLOAD_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_UNKNOWN", value: 0 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED0", value: 200 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED1", value: 201 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED2", value: 202 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED3", value: 203 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED4", value: 204 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED5", value: 205 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED6", value: 206 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED7", value: 207 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED8", value: 208 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_STORM32_RESERVED9", value: 209 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_MODALAI_REMOTE_OSD", value: 210 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_MODALAI_ESC_UART_PASSTHRU", value: 211 },
      { name: "MAV_TUNNEL_PAYLOAD_TYPE_MODALAI_IO_UART_PASSTHRU", value: 212 },
    ],
  },
  {
    name: "MAV_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAV_TYPE_GENERIC", value: 0 },
      { name: "MAV_TYPE_FIXED_WING", value: 1 },
      { name: "MAV_TYPE_QUADROTOR", value: 2 },
      { name: "MAV_TYPE_COAXIAL", value: 3 },
      { name: "MAV_TYPE_HELICOPTER", value: 4 },
      { name: "MAV_TYPE_ANTENNA_TRACKER", value: 5 },
      { name: "MAV_TYPE_GCS", value: 6 },
      { name: "MAV_TYPE_AIRSHIP", value: 7 },
      { name: "MAV_TYPE_FREE_BALLOON", value: 8 },
      { name: "MAV_TYPE_ROCKET", value: 9 },
      { name: "MAV_TYPE_GROUND_ROVER", value: 10 },
      { name: "MAV_TYPE_SURFACE_BOAT", value: 11 },
      { name: "MAV_TYPE_SUBMARINE", value: 12 },
      { name: "MAV_TYPE_HEXAROTOR", value: 13 },
      { name: "MAV_TYPE_OCTOROTOR", value: 14 },
      { name: "MAV_TYPE_TRICOPTER", value: 15 },
      { name: "MAV_TYPE_FLAPPING_WING", value: 16 },
      { name: "MAV_TYPE_KITE", value: 17 },
      { name: "MAV_TYPE_ONBOARD_CONTROLLER", value: 18 },
      { name: "MAV_TYPE_VTOL_TAILSITTER_DUOROTOR", value: 19 },
      { name: "MAV_TYPE_VTOL_TAILSITTER_QUADROTOR", value: 20 },
      { name: "MAV_TYPE_VTOL_TILTROTOR", value: 21 },
      { name: "MAV_TYPE_VTOL_FIXEDROTOR", value: 22 },
      { name: "MAV_TYPE_VTOL_TAILSITTER", value: 23 },
      { name: "MAV_TYPE_VTOL_TILTWING", value: 24 },
      { name: "MAV_TYPE_VTOL_RESERVED5", value: 25 },
      { name: "MAV_TYPE_GIMBAL", value: 26 },
      { name: "MAV_TYPE_ADSB", value: 27 },
      { name: "MAV_TYPE_PARAFOIL", value: 28 },
      { name: "MAV_TYPE_DODECAROTOR", value: 29 },
      { name: "MAV_TYPE_CAMERA", value: 30 },
      { name: "MAV_TYPE_CHARGING_STATION", value: 31 },
      { name: "MAV_TYPE_FLARM", value: 32 },
      { name: "MAV_TYPE_SERVO", value: 33 },
      { name: "MAV_TYPE_ODID", value: 34 },
      { name: "MAV_TYPE_DECAROTOR", value: 35 },
      { name: "MAV_TYPE_BATTERY", value: 36 },
      { name: "MAV_TYPE_PARACHUTE", value: 37 },
      { name: "MAV_TYPE_LOG", value: 38 },
      { name: "MAV_TYPE_OSD", value: 39 },
      { name: "MAV_TYPE_IMU", value: 40 },
      { name: "MAV_TYPE_GPS", value: 41 },
      { name: "MAV_TYPE_WINCH", value: 42 },
      { name: "MAV_TYPE_GENERIC_MULTIROTOR", value: 43 },
      { name: "MAV_TYPE_ILLUMINATOR", value: 44 },
      { name: "MAV_TYPE_SPACECRAFT_ORBITER", value: 45 },
      { name: "MAV_TYPE_GROUND_QUADRUPED", value: 46 },
      { name: "MAV_TYPE_VTOL_GYRODYNE", value: 47 },
      { name: "MAV_TYPE_GRIPPER", value: 48 },
      { name: "MAV_TYPE_RADIO", value: 49 },
    ],
  },
  {
    name: "MAV_VTOL_STATE",
    isBitmask: false,
    entries: [
      { name: "MAV_VTOL_STATE_UNDEFINED", value: 0 },
      { name: "MAV_VTOL_STATE_TRANSITION_TO_FW", value: 1 },
      { name: "MAV_VTOL_STATE_TRANSITION_TO_MC", value: 2 },
      { name: "MAV_VTOL_STATE_MC", value: 3 },
      { name: "MAV_VTOL_STATE_FW", value: 4 },
    ],
  },
  {
    name: "MAV_WINCH_STATUS_FLAG",
    isBitmask: true,
    entries: [
      { name: "MAV_WINCH_STATUS_HEALTHY", value: 1 },
      { name: "MAV_WINCH_STATUS_FULLY_RETRACTED", value: 2 },
      { name: "MAV_WINCH_STATUS_MOVING", value: 4 },
      { name: "MAV_WINCH_STATUS_CLUTCH_DISENGAGED", value: 8 },
      { name: "MAV_WINCH_STATUS_LOCKED", value: 16 },
      { name: "MAV_WINCH_STATUS_DROPPING", value: 32 },
      { name: "MAV_WINCH_STATUS_ARRESTING", value: 64 },
      { name: "MAV_WINCH_STATUS_GROUND_SENSE", value: 128 },
      { name: "MAV_WINCH_STATUS_RETRACTING", value: 256 },
      { name: "MAV_WINCH_STATUS_REDELIVER", value: 512 },
      { name: "MAV_WINCH_STATUS_ABANDON_LINE", value: 1024 },
      { name: "MAV_WINCH_STATUS_LOCKING", value: 2048 },
      { name: "MAV_WINCH_STATUS_LOAD_LINE", value: 4096 },
      { name: "MAV_WINCH_STATUS_LOAD_PAYLOAD", value: 8192 },
    ],
  },
  {
    name: "MAVLINK_DATA_STREAM_TYPE",
    isBitmask: false,
    entries: [
      { name: "MAVLINK_DATA_STREAM_IMG_JPEG", value: 0 },
      { name: "MAVLINK_DATA_STREAM_IMG_BMP", value: 1 },
      { name: "MAVLINK_DATA_STREAM_IMG_RAW8U", value: 2 },
      { name: "MAVLINK_DATA_STREAM_IMG_RAW32U", value: 3 },
      { name: "MAVLINK_DATA_STREAM_IMG_PGM", value: 4 },
      { name: "MAVLINK_DATA_STREAM_IMG_PNG", value: 5 },
    ],
  },
  {
    name: "MISSION_STATE",
    isBitmask: false,
    entries: [
      { name: "MISSION_STATE_UNKNOWN", value: 0 },
      { name: "MISSION_STATE_NO_MISSION", value: 1 },
      { name: "MISSION_STATE_NOT_STARTED", value: 2 },
      { name: "MISSION_STATE_ACTIVE", value: 3 },
      { name: "MISSION_STATE_PAUSED", value: 4 },
      { name: "MISSION_STATE_COMPLETE", value: 5 },
    ],
  },
  {
    name: "MOTOR_TEST_ORDER",
    isBitmask: false,
    entries: [
      { name: "MOTOR_TEST_ORDER_DEFAULT", value: 0 },
      { name: "MOTOR_TEST_ORDER_SEQUENCE", value: 1 },
      { name: "MOTOR_TEST_ORDER_BOARD", value: 2 },
    ],
  },
  {
    name: "MOTOR_TEST_THROTTLE_TYPE",
    isBitmask: false,
    entries: [
      { name: "MOTOR_TEST_THROTTLE_PERCENT", value: 0 },
      { name: "MOTOR_TEST_THROTTLE_PWM", value: 1 },
      { name: "MOTOR_TEST_THROTTLE_PILOT", value: 2 },
      { name: "MOTOR_TEST_COMPASS_CAL", value: 3 },
    ],
  },
  {
    name: "NAV_TAKEOFF_FLAGS",
    isBitmask: true,
    entries: [
      { name: "NAV_TAKEOFF_FLAGS_HORIZONTAL_POSITION_NOT_REQUIRED", value: 1 },
    ],
  },
  {
    name: "NAV_VTOL_LAND_OPTIONS",
    isBitmask: false,
    entries: [
      { name: "NAV_VTOL_LAND_OPTIONS_DEFAULT", value: 0 },
      { name: "NAV_VTOL_LAND_OPTIONS_FW_SPIRAL_APPROACH", value: 1 },
      { name: "NAV_VTOL_LAND_OPTIONS_FW_APPROACH", value: 2 },
    ],
  },
  {
    name: "ORBIT_YAW_BEHAVIOUR",
    isBitmask: false,
    entries: [
      { name: "ORBIT_YAW_BEHAVIOUR_HOLD_FRONT_TO_CIRCLE_CENTER", value: 0 },
      { name: "ORBIT_YAW_BEHAVIOUR_HOLD_INITIAL_HEADING", value: 1 },
      { name: "ORBIT_YAW_BEHAVIOUR_UNCONTROLLED", value: 2 },
      { name: "ORBIT_YAW_BEHAVIOUR_HOLD_FRONT_TANGENT_TO_CIRCLE", value: 3 },
      { name: "ORBIT_YAW_BEHAVIOUR_RC_CONTROLLED", value: 4 },
      { name: "ORBIT_YAW_BEHAVIOUR_UNCHANGED", value: 5 },
    ],
  },
  {
    name: "OSD_PARAM_CONFIG_ERROR",
    isBitmask: false,
    entries: [
      { name: "OSD_PARAM_SUCCESS", value: 0 },
      { name: "OSD_PARAM_INVALID_SCREEN", value: 1 },
      { name: "OSD_PARAM_INVALID_PARAMETER_INDEX", value: 2 },
      { name: "OSD_PARAM_INVALID_PARAMETER", value: 3 },
    ],
  },
  {
    name: "OSD_PARAM_CONFIG_TYPE",
    isBitmask: false,
    entries: [
      { name: "OSD_PARAM_NONE", value: 0 },
      { name: "OSD_PARAM_SERIAL_PROTOCOL", value: 1 },
      { name: "OSD_PARAM_SERVO_FUNCTION", value: 2 },
      { name: "OSD_PARAM_AUX_FUNCTION", value: 3 },
      { name: "OSD_PARAM_FLIGHT_MODE", value: 4 },
      { name: "OSD_PARAM_FAILSAFE_ACTION", value: 5 },
      { name: "OSD_PARAM_FAILSAFE_ACTION_1", value: 6 },
      { name: "OSD_PARAM_FAILSAFE_ACTION_2", value: 7 },
      { name: "OSD_PARAM_NUM_TYPES", value: 8 },
    ],
  },
  {
    name: "PARACHUTE_ACTION",
    isBitmask: false,
    entries: [
      { name: "PARACHUTE_DISABLE", value: 0 },
      { name: "PARACHUTE_ENABLE", value: 1 },
      { name: "PARACHUTE_RELEASE", value: 2 },
    ],
  },
  {
    name: "PARAM_ACK",
    isBitmask: false,
    entries: [
      { name: "PARAM_ACK_ACCEPTED", value: 0 },
      { name: "PARAM_ACK_VALUE_UNSUPPORTED", value: 1 },
      { name: "PARAM_ACK_FAILED", value: 2 },
      { name: "PARAM_ACK_IN_PROGRESS", value: 3 },
    ],
  },
  {
    name: "PID_TUNING_AXIS",
    isBitmask: false,
    entries: [
      { name: "PID_TUNING_ROLL", value: 1 },
      { name: "PID_TUNING_PITCH", value: 2 },
      { name: "PID_TUNING_YAW", value: 3 },
      { name: "PID_TUNING_ACCZ", value: 4 },
      { name: "PID_TUNING_STEER", value: 5 },
      { name: "PID_TUNING_LANDING", value: 6 },
      { name: "PID_TUNING_WHEEL_LEFT", value: 7 },
      { name: "PID_TUNING_WHEEL_RIGHT", value: 8 },
      { name: "PID_TUNING_SAIL_HEEL", value: 9 },
      { name: "PID_TUNING_VEL_NORTH", value: 10 },
      { name: "PID_TUNING_VEL_EAST", value: 11 },
      { name: "PID_TUNING_VEL_DOWN", value: 12 },
      { name: "PID_TUNING_POS_NORTH", value: 13 },
      { name: "PID_TUNING_POS_EAST", value: 14 },
      { name: "PID_TUNING_POS_DOWN", value: 15 },
      { name: "PID_TUNING_YAW_ANGLE", value: 16 },
    ],
  },
  {
    name: "PLANE_MODE",
    isBitmask: false,
    entries: [
      { name: "PLANE_MODE_MANUAL", value: 0 },
      { name: "PLANE_MODE_CIRCLE", value: 1 },
      { name: "PLANE_MODE_STABILIZE", value: 2 },
      { name: "PLANE_MODE_TRAINING", value: 3 },
      { name: "PLANE_MODE_ACRO", value: 4 },
      { name: "PLANE_MODE_FLY_BY_WIRE_A", value: 5 },
      { name: "PLANE_MODE_FLY_BY_WIRE_B", value: 6 },
      { name: "PLANE_MODE_CRUISE", value: 7 },
      { name: "PLANE_MODE_AUTOTUNE", value: 8 },
      { name: "PLANE_MODE_AUTO", value: 10 },
      { name: "PLANE_MODE_RTL", value: 11 },
      { name: "PLANE_MODE_LOITER", value: 12 },
      { name: "PLANE_MODE_TAKEOFF", value: 13 },
      { name: "PLANE_MODE_AVOID_ADSB", value: 14 },
      { name: "PLANE_MODE_GUIDED", value: 15 },
      { name: "PLANE_MODE_INITIALIZING", value: 16 },
      { name: "PLANE_MODE_QSTABILIZE", value: 17 },
      { name: "PLANE_MODE_QHOVER", value: 18 },
      { name: "PLANE_MODE_QLOITER", value: 19 },
      { name: "PLANE_MODE_QLAND", value: 20 },
      { name: "PLANE_MODE_QRTL", value: 21 },
      { name: "PLANE_MODE_QAUTOTUNE", value: 22 },
      { name: "PLANE_MODE_QACRO", value: 23 },
      { name: "PLANE_MODE_THERMAL", value: 24 },
      { name: "PLANE_MODE_LOITER_ALT_QLAND", value: 25 },
      { name: "PLANE_MODE_AUTOLAND", value: 26 },
    ],
  },
  {
    name: "POSITION_TARGET_TYPEMASK",
    isBitmask: true,
    entries: [
      { name: "POSITION_TARGET_TYPEMASK_X_IGNORE", value: 1 },
      { name: "POSITION_TARGET_TYPEMASK_Y_IGNORE", value: 2 },
      { name: "POSITION_TARGET_TYPEMASK_Z_IGNORE", value: 4 },
      { name: "POSITION_TARGET_TYPEMASK_VX_IGNORE", value: 8 },
      { name: "POSITION_TARGET_TYPEMASK_VY_IGNORE", value: 16 },
      { name: "POSITION_TARGET_TYPEMASK_VZ_IGNORE", value: 32 },
      { name: "POSITION_TARGET_TYPEMASK_AX_IGNORE", value: 64 },
      { name: "POSITION_TARGET_TYPEMASK_AY_IGNORE", value: 128 },
      { name: "POSITION_TARGET_TYPEMASK_AZ_IGNORE", value: 256 },
      { name: "POSITION_TARGET_TYPEMASK_FORCE_SET", value: 512 },
      { name: "POSITION_TARGET_TYPEMASK_YAW_IGNORE", value: 1024 },
      { name: "POSITION_TARGET_TYPEMASK_YAW_RATE_IGNORE", value: 2048 },
    ],
  },
  {
    name: "PRECISION_LAND_MODE",
    isBitmask: false,
    entries: [
      { name: "PRECISION_LAND_MODE_DISABLED", value: 0 },
      { name: "PRECISION_LAND_MODE_OPPORTUNISTIC", value: 1 },
      { name: "PRECISION_LAND_MODE_REQUIRED", value: 2 },
    ],
  },
  {
    name: "PREFLIGHT_CALIBRATION_ACCELEROMETER",
    isBitmask: false,
    entries: [
      { name: "PREFLIGHT_CALIBRATION_ACCELEROMETER_NONE", value: 0 },
      { name: "PREFLIGHT_CALIBRATION_ACCELEROMETER_FULL", value: 1 },
      { name: "PREFLIGHT_CALIBRATION_ACCELEROMETER_TRIM", value: 2 },
      { name: "PREFLIGHT_CALIBRATION_ACCELEROMETER_TEMPERATURE", value: 3 },
      { name: "PREFLIGHT_CALIBRATION_ACCELEROMETER_SIMPLE", value: 4 },
      { name: "PREFLIGHT_CALIBRATION_ACCELEROMETER_FORCE_SAVE", value: 76 },
    ],
  },
  {
    name: "PREFLIGHT_CALIBRATION_MAGNETOMETER",
    isBitmask: false,
    entries: [
      { name: "PREFLIGHT_CALIBRATION_MAGNETOMETER_NONE", value: 0 },
      { name: "PREFLIGHT_CALIBRATION_MAGNETOMETER_START", value: 1 },
      { name: "PREFLIGHT_CALIBRATION_MAGNETOMETER_FORCE_SAVE", value: 76 },
    ],
  },
  {
    name: "PREFLIGHT_STORAGE_PARAMETER_ACTION",
    isBitmask: false,
    entries: [
      { name: "PARAM_READ_PERSISTENT", value: 0 },
      { name: "PARAM_WRITE_PERSISTENT", value: 1 },
      { name: "PARAM_RESET_FACTORY_DEFAULT", value: 2 },
      { name: "PARAM_RESET_SENSOR_DEFAULT", value: 3 },
      { name: "PARAM_RESET_ALL_DEFAULT", value: 4 },
    ],
  },
  {
    name: "RADIO_RC_CHANNELS_FLAGS",
    isBitmask: true,
    entries: [
      { name: "RADIO_RC_CHANNELS_FLAGS_FAILSAFE", value: 1 },
      { name: "RADIO_RC_CHANNELS_FLAGS_OUTDATED", value: 2 },
    ],
  },
  {
    name: "RALLY_FLAGS",
    isBitmask: false,
    entries: [
      { name: "FAVORABLE_WIND", value: 1 },
      { name: "LAND_IMMEDIATELY", value: 2 },
      { name: "ALT_FRAME_VALID", value: 4 },
      { name: "ALT_FRAME", value: 24 },
    ],
  },
  {
    name: "RC_SUB_TYPE",
    isBitmask: false,
    entries: [
      { name: "RC_SUB_TYPE_SPEKTRUM_DSM2", value: 0 },
      { name: "RC_SUB_TYPE_SPEKTRUM_DSMX", value: 1 },
      { name: "RC_SUB_TYPE_SPEKTRUM_DSMX8", value: 2 },
    ],
  },
  {
    name: "RC_TYPE",
    isBitmask: false,
    entries: [
      { name: "RC_TYPE_SPEKTRUM", value: 0 },
      { name: "RC_TYPE_CRSF", value: 1 },
    ],
  },
  {
    name: "REBOOT_SHUTDOWN_ACTION",
    isBitmask: false,
    entries: [
      { name: "REBOOT_SHUTDOWN_ACTION_NONE", value: 0 },
      { name: "REBOOT_SHUTDOWN_ACTION_REBOOT", value: 1 },
      { name: "REBOOT_SHUTDOWN_ACTION_SHUTDOWN", value: 2 },
      { name: "REBOOT_SHUTDOWN_ACTION_REBOOT_TO_BOOTLOADER", value: 3 },
      { name: "REBOOT_SHUTDOWN_ACTION_POWER_ON", value: 4 },
      { name: "REBOOT_SHUTDOWN_ACTION_REBOOT_TO_MASS_STORAGE", value: 5 },
    ],
  },
  {
    name: "REBOOT_SHUTDOWN_CONDITIONS",
    isBitmask: false,
    entries: [
      { name: "REBOOT_SHUTDOWN_CONDITIONS_SAFETY_INTERLOCKED", value: 0 },
      { name: "REBOOT_SHUTDOWN_CONDITIONS_FORCE", value: 20190226 },
    ],
  },
  {
    name: "ROVER_MODE",
    isBitmask: false,
    entries: [
      { name: "ROVER_MODE_MANUAL", value: 0 },
      { name: "ROVER_MODE_ACRO", value: 1 },
      { name: "ROVER_MODE_STEERING", value: 3 },
      { name: "ROVER_MODE_HOLD", value: 4 },
      { name: "ROVER_MODE_LOITER", value: 5 },
      { name: "ROVER_MODE_FOLLOW", value: 6 },
      { name: "ROVER_MODE_SIMPLE", value: 7 },
      { name: "ROVER_MODE_DOCK", value: 8 },
      { name: "ROVER_MODE_CIRCLE", value: 9 },
      { name: "ROVER_MODE_AUTO", value: 10 },
      { name: "ROVER_MODE_RTL", value: 11 },
      { name: "ROVER_MODE_SMART_RTL", value: 12 },
      { name: "ROVER_MODE_GUIDED", value: 15 },
      { name: "ROVER_MODE_INITIALIZING", value: 16 },
    ],
  },
  {
    name: "RTK_BASELINE_COORDINATE_SYSTEM",
    isBitmask: false,
    entries: [
      { name: "RTK_BASELINE_COORDINATE_SYSTEM_ECEF", value: 0 },
      { name: "RTK_BASELINE_COORDINATE_SYSTEM_NED", value: 1 },
    ],
  },
  {
    name: "SAFETY_SWITCH_STATE",
    isBitmask: false,
    entries: [
      { name: "SAFETY_SWITCH_STATE_SAFE", value: 0 },
      { name: "SAFETY_SWITCH_STATE_DANGEROUS", value: 1 },
    ],
  },
  {
    name: "SCRIPTING_CMD",
    isBitmask: false,
    entries: [
      { name: "SCRIPTING_CMD_REPL_START", value: 0 },
      { name: "SCRIPTING_CMD_REPL_STOP", value: 1 },
      { name: "SCRIPTING_CMD_STOP", value: 2 },
      { name: "SCRIPTING_CMD_STOP_AND_RESTART", value: 3 },
    ],
  },
  {
    name: "SECURE_COMMAND_OP",
    isBitmask: false,
    entries: [
      { name: "SECURE_COMMAND_GET_SESSION_KEY", value: 0 },
      { name: "SECURE_COMMAND_GET_REMOTEID_SESSION_KEY", value: 1 },
      { name: "SECURE_COMMAND_REMOVE_PUBLIC_KEYS", value: 2 },
      { name: "SECURE_COMMAND_GET_PUBLIC_KEYS", value: 3 },
      { name: "SECURE_COMMAND_SET_PUBLIC_KEYS", value: 4 },
      { name: "SECURE_COMMAND_GET_REMOTEID_CONFIG", value: 5 },
      { name: "SECURE_COMMAND_SET_REMOTEID_CONFIG", value: 6 },
      { name: "SECURE_COMMAND_FLASH_BOOTLOADER", value: 7 },
    ],
  },
  {
    name: "SERIAL_CONTROL_DEV",
    isBitmask: false,
    entries: [
      { name: "SERIAL_CONTROL_DEV_TELEM1", value: 0 },
      { name: "SERIAL_CONTROL_DEV_TELEM2", value: 1 },
      { name: "SERIAL_CONTROL_DEV_GPS1", value: 2 },
      { name: "SERIAL_CONTROL_DEV_GPS2", value: 3 },
      { name: "SERIAL_CONTROL_DEV_TELEM3", value: 4 },
      { name: "SERIAL_CONTROL_DEV_TELEM4", value: 5 },
      { name: "SERIAL_CONTROL_DEV_SHELL", value: 10 },
      { name: "SERIAL_CONTROL_DEV_ESC0", value: 20 },
      { name: "SERIAL_CONTROL_DEV_ESC1", value: 21 },
      { name: "SERIAL_CONTROL_DEV_ESC2", value: 22 },
      { name: "SERIAL_CONTROL_DEV_ESC3", value: 23 },
      { name: "SERIAL_CONTROL_DEV_ESC4", value: 24 },
      { name: "SERIAL_CONTROL_DEV_ESC5", value: 25 },
      { name: "SERIAL_CONTROL_DEV_ESC6", value: 26 },
      { name: "SERIAL_CONTROL_DEV_ESC7", value: 27 },
      { name: "SERIAL_CONTROL_SERIAL0", value: 100 },
      { name: "SERIAL_CONTROL_SERIAL1", value: 101 },
      { name: "SERIAL_CONTROL_SERIAL2", value: 102 },
      { name: "SERIAL_CONTROL_SERIAL3", value: 103 },
      { name: "SERIAL_CONTROL_SERIAL4", value: 104 },
      { name: "SERIAL_CONTROL_SERIAL5", value: 105 },
      { name: "SERIAL_CONTROL_SERIAL6", value: 106 },
      { name: "SERIAL_CONTROL_SERIAL7", value: 107 },
      { name: "SERIAL_CONTROL_SERIAL8", value: 108 },
      { name: "SERIAL_CONTROL_SERIAL9", value: 109 },
    ],
  },
  {
    name: "SERIAL_CONTROL_FLAG",
    isBitmask: true,
    entries: [
      { name: "SERIAL_CONTROL_FLAG_REPLY", value: 1 },
      { name: "SERIAL_CONTROL_FLAG_RESPOND", value: 2 },
      { name: "SERIAL_CONTROL_FLAG_EXCLUSIVE", value: 4 },
      { name: "SERIAL_CONTROL_FLAG_BLOCKING", value: 8 },
      { name: "SERIAL_CONTROL_FLAG_MULTI", value: 16 },
    ],
  },
  {
    name: "SET_FOCUS_TYPE",
    isBitmask: false,
    entries: [
      { name: "FOCUS_TYPE_STEP", value: 0 },
      { name: "FOCUS_TYPE_CONTINUOUS", value: 1 },
      { name: "FOCUS_TYPE_RANGE", value: 2 },
      { name: "FOCUS_TYPE_METERS", value: 3 },
      { name: "FOCUS_TYPE_AUTO", value: 4 },
      { name: "FOCUS_TYPE_AUTO_SINGLE", value: 5 },
      { name: "FOCUS_TYPE_AUTO_CONTINUOUS", value: 6 },
    ],
  },
  {
    name: "SPEED_TYPE",
    isBitmask: false,
    entries: [
      { name: "SPEED_TYPE_AIRSPEED", value: 0 },
      { name: "SPEED_TYPE_GROUNDSPEED", value: 1 },
      { name: "SPEED_TYPE_CLIMB_SPEED", value: 2 },
      { name: "SPEED_TYPE_DESCENT_SPEED", value: 3 },
    ],
  },
  {
    name: "STORAGE_STATUS",
    isBitmask: false,
    entries: [
      { name: "STORAGE_STATUS_EMPTY", value: 0 },
      { name: "STORAGE_STATUS_UNFORMATTED", value: 1 },
      { name: "STORAGE_STATUS_READY", value: 2 },
      { name: "STORAGE_STATUS_NOT_SUPPORTED", value: 3 },
    ],
  },
  {
    name: "STORAGE_TYPE",
    isBitmask: false,
    entries: [
      { name: "STORAGE_TYPE_UNKNOWN", value: 0 },
      { name: "STORAGE_TYPE_USB_STICK", value: 1 },
      { name: "STORAGE_TYPE_SD", value: 2 },
      { name: "STORAGE_TYPE_MICROSD", value: 3 },
      { name: "STORAGE_TYPE_CF", value: 4 },
      { name: "STORAGE_TYPE_CFE", value: 5 },
      { name: "STORAGE_TYPE_XQD", value: 6 },
      { name: "STORAGE_TYPE_HD", value: 7 },
      { name: "STORAGE_TYPE_OTHER", value: 254 },
    ],
  },
  {
    name: "STORAGE_USAGE_FLAG",
    isBitmask: true,
    entries: [
      { name: "STORAGE_USAGE_FLAG_SET", value: 1 },
      { name: "STORAGE_USAGE_FLAG_PHOTO", value: 2 },
      { name: "STORAGE_USAGE_FLAG_VIDEO", value: 4 },
      { name: "STORAGE_USAGE_FLAG_LOGS", value: 8 },
    ],
  },
  {
    name: "SUB_MODE",
    isBitmask: false,
    entries: [
      { name: "SUB_MODE_STABILIZE", value: 0 },
      { name: "SUB_MODE_ACRO", value: 1 },
      { name: "SUB_MODE_ALT_HOLD", value: 2 },
      { name: "SUB_MODE_AUTO", value: 3 },
      { name: "SUB_MODE_GUIDED", value: 4 },
      { name: "SUB_MODE_CIRCLE", value: 7 },
      { name: "SUB_MODE_SURFACE", value: 9 },
      { name: "SUB_MODE_POSHOLD", value: 16 },
      { name: "SUB_MODE_MANUAL", value: 19 },
      { name: "SUB_MODE_MOTORDETECT", value: 20 },
      { name: "SUB_MODE_SURFTRAK", value: 21 },
    ],
  },
  {
    name: "TRACKER_MODE",
    isBitmask: false,
    entries: [
      { name: "TRACKER_MODE_MANUAL", value: 0 },
      { name: "TRACKER_MODE_STOP", value: 1 },
      { name: "TRACKER_MODE_SCAN", value: 2 },
      { name: "TRACKER_MODE_SERVO_TEST", value: 3 },
      { name: "TRACKER_MODE_GUIDED", value: 4 },
      { name: "TRACKER_MODE_AUTO", value: 10 },
      { name: "TRACKER_MODE_INITIALIZING", value: 16 },
    ],
  },
  {
    name: "TUNE_FORMAT",
    isBitmask: false,
    entries: [
      { name: "TUNE_FORMAT_QBASIC1_1", value: 1 },
      { name: "TUNE_FORMAT_MML_MODERN", value: 2 },
    ],
  },
  {
    name: "UAVCAN_NODE_HEALTH",
    isBitmask: false,
    entries: [
      { name: "UAVCAN_NODE_HEALTH_OK", value: 0 },
      { name: "UAVCAN_NODE_HEALTH_WARNING", value: 1 },
      { name: "UAVCAN_NODE_HEALTH_ERROR", value: 2 },
      { name: "UAVCAN_NODE_HEALTH_CRITICAL", value: 3 },
    ],
  },
  {
    name: "UAVCAN_NODE_MODE",
    isBitmask: false,
    entries: [
      { name: "UAVCAN_NODE_MODE_OPERATIONAL", value: 0 },
      { name: "UAVCAN_NODE_MODE_INITIALIZATION", value: 1 },
      { name: "UAVCAN_NODE_MODE_MAINTENANCE", value: 2 },
      { name: "UAVCAN_NODE_MODE_SOFTWARE_UPDATE", value: 3 },
      { name: "UAVCAN_NODE_MODE_OFFLINE", value: 7 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_EMERGENCY_STATUS",
    isBitmask: false,
    entries: [
      { name: "UAVIONIX_ADSB_OUT_NO_EMERGENCY", value: 0 },
      { name: "UAVIONIX_ADSB_OUT_GENERAL_EMERGENCY", value: 1 },
      { name: "UAVIONIX_ADSB_OUT_LIFEGUARD_EMERGENCY", value: 2 },
      { name: "UAVIONIX_ADSB_OUT_MINIMUM_FUEL_EMERGENCY", value: 3 },
      { name: "UAVIONIX_ADSB_OUT_NO_COMM_EMERGENCY", value: 4 },
      { name: "UAVIONIX_ADSB_OUT_UNLAWFUL_INTERFERANCE_EMERGENCY", value: 5 },
      { name: "UAVIONIX_ADSB_OUT_DOWNED_AIRCRAFT_EMERGENCY", value: 6 },
      { name: "UAVIONIX_ADSB_OUT_RESERVED", value: 7 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE",
    isBitmask: false,
    entries: [
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_NO_DATA", value: 0 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L15M_W23M", value: 1 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L25M_W28P5M", value: 2 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L25_34M", value: 3 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L35_33M", value: 4 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L35_38M", value: 5 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L45_39P5M", value: 6 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L45_45M", value: 7 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L55_45M", value: 8 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L55_52M", value: 9 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L65_59P5M", value: 10 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L65_67M", value: 11 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L75_W72P5M", value: 12 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L75_W80M", value: 13 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L85_W80M", value: 14 },
      { name: "UAVIONIX_ADSB_OUT_CFG_AIRCRAFT_SIZE_L85_W90M", value: 15 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT",
    isBitmask: false,
    entries: [
      { name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_NO_DATA", value: 0 },
      { name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_LEFT_2M", value: 1 },
      { name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_LEFT_4M", value: 2 },
      { name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_LEFT_6M", value: 3 },
      { name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_RIGHT_0M", value: 4 },
      { name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_RIGHT_2M", value: 5 },
      { name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_RIGHT_4M", value: 6 },
      { name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LAT_RIGHT_6M", value: 7 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LON",
    isBitmask: false,
    entries: [
      { name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LON_NO_DATA", value: 0 },
      { name: "UAVIONIX_ADSB_OUT_CFG_GPS_OFFSET_LON_APPLIED_BY_SENSOR", value: 1 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_OUT_CONTROL_STATE",
    isBitmask: true,
    entries: [
      { name: "UAVIONIX_ADSB_OUT_CONTROL_STATE_EXTERNAL_BARO_CROSSCHECKED", value: 1 },
      { name: "UAVIONIX_ADSB_OUT_CONTROL_STATE_ON_GROUND", value: 4 },
      { name: "UAVIONIX_ADSB_OUT_CONTROL_STATE_IDENT_BUTTON_ACTIVE", value: 8 },
      { name: "UAVIONIX_ADSB_OUT_CONTROL_STATE_MODE_A_ENABLED", value: 16 },
      { name: "UAVIONIX_ADSB_OUT_CONTROL_STATE_MODE_C_ENABLED", value: 32 },
      { name: "UAVIONIX_ADSB_OUT_CONTROL_STATE_MODE_S_ENABLED", value: 64 },
      { name: "UAVIONIX_ADSB_OUT_CONTROL_STATE_1090ES_TX_ENABLED", value: 128 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX",
    isBitmask: false,
    entries: [
      { name: "UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_NONE_0", value: 0 },
      { name: "UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_NONE_1", value: 1 },
      { name: "UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_2D", value: 2 },
      { name: "UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_3D", value: 3 },
      { name: "UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_DGPS", value: 4 },
      { name: "UAVIONIX_ADSB_OUT_DYNAMIC_GPS_FIX_RTK", value: 5 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_OUT_DYNAMIC_STATE",
    isBitmask: true,
    entries: [
      { name: "UAVIONIX_ADSB_OUT_DYNAMIC_STATE_INTENT_CHANGE", value: 1 },
      { name: "UAVIONIX_ADSB_OUT_DYNAMIC_STATE_AUTOPILOT_ENABLED", value: 2 },
      { name: "UAVIONIX_ADSB_OUT_DYNAMIC_STATE_NICBARO_CROSSCHECKED", value: 4 },
      { name: "UAVIONIX_ADSB_OUT_DYNAMIC_STATE_ON_GROUND", value: 8 },
      { name: "UAVIONIX_ADSB_OUT_DYNAMIC_STATE_IDENT", value: 16 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_OUT_RF_SELECT",
    isBitmask: true,
    entries: [
      { name: "UAVIONIX_ADSB_OUT_RF_SELECT_RX_ENABLED", value: 1 },
      { name: "UAVIONIX_ADSB_OUT_RF_SELECT_TX_ENABLED", value: 2 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_OUT_STATUS_FAULT",
    isBitmask: true,
    entries: [
      { name: "UAVIONIX_ADSB_OUT_STATUS_FAULT_STATUS_MESSAGE_UNAVAIL", value: 8 },
      { name: "UAVIONIX_ADSB_OUT_STATUS_FAULT_GPS_NO_POS", value: 16 },
      { name: "UAVIONIX_ADSB_OUT_STATUS_FAULT_GPS_UNAVAIL", value: 32 },
      { name: "UAVIONIX_ADSB_OUT_STATUS_FAULT_TX_SYSTEM_FAIL", value: 64 },
      { name: "UAVIONIX_ADSB_OUT_STATUS_FAULT_MAINT_REQ", value: 128 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_OUT_STATUS_NIC_NACP",
    isBitmask: false,
    entries: [
      { name: "UAVIONIX_ADSB_NIC_CR_20_NM", value: 1 },
      { name: "UAVIONIX_ADSB_NIC_CR_8_NM", value: 2 },
      { name: "UAVIONIX_ADSB_NIC_CR_4_NM", value: 3 },
      { name: "UAVIONIX_ADSB_NIC_CR_2_NM", value: 4 },
      { name: "UAVIONIX_ADSB_NIC_CR_1_NM", value: 5 },
      { name: "UAVIONIX_ADSB_NIC_CR_0_3_NM", value: 6 },
      { name: "UAVIONIX_ADSB_NIC_CR_0_2_NM", value: 7 },
      { name: "UAVIONIX_ADSB_NIC_CR_0_1_NM", value: 8 },
      { name: "UAVIONIX_ADSB_NIC_CR_75_M", value: 9 },
      { name: "UAVIONIX_ADSB_NIC_CR_25_M", value: 10 },
      { name: "UAVIONIX_ADSB_NIC_CR_7_5_M", value: 11 },
      { name: "UAVIONIX_ADSB_NACP_EPU_10_NM", value: 16 },
      { name: "UAVIONIX_ADSB_NACP_EPU_4_NM", value: 32 },
      { name: "UAVIONIX_ADSB_NACP_EPU_2_NM", value: 48 },
      { name: "UAVIONIX_ADSB_NACP_EPU_1_NM", value: 64 },
      { name: "UAVIONIX_ADSB_NACP_EPU_0_5_NM", value: 80 },
      { name: "UAVIONIX_ADSB_NACP_EPU_0_3_NM", value: 96 },
      { name: "UAVIONIX_ADSB_NACP_EPU_0_1_NM", value: 112 },
      { name: "UAVIONIX_ADSB_NACP_EPU_0_05_NM", value: 128 },
      { name: "UAVIONIX_ADSB_NACP_EPU_30_M", value: 144 },
      { name: "UAVIONIX_ADSB_NACP_EPU_10_M", value: 160 },
      { name: "UAVIONIX_ADSB_NACP_EPU_3_M", value: 176 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_OUT_STATUS_STATE",
    isBitmask: true,
    entries: [
      { name: "UAVIONIX_ADSB_OUT_STATUS_STATE_ON_GROUND", value: 1 },
      { name: "UAVIONIX_ADSB_OUT_STATUS_STATE_INTERROGATED_SINCE_LAST", value: 2 },
      { name: "UAVIONIX_ADSB_OUT_STATUS_STATE_XBIT_ENABLED", value: 4 },
      { name: "UAVIONIX_ADSB_OUT_STATUS_STATE_IDENT_ACTIVE", value: 8 },
      { name: "UAVIONIX_ADSB_OUT_STATUS_STATE_MODE_A_ENABLED", value: 16 },
      { name: "UAVIONIX_ADSB_OUT_STATUS_STATE_MODE_C_ENABLED", value: 32 },
      { name: "UAVIONIX_ADSB_OUT_STATUS_STATE_MODE_S_ENABLED", value: 64 },
      { name: "UAVIONIX_ADSB_OUT_STATUS_STATE_1090ES_TX_ENABLED", value: 128 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_RF_HEALTH",
    isBitmask: true,
    entries: [
      { name: "UAVIONIX_ADSB_RF_HEALTH_OK", value: 1 },
      { name: "UAVIONIX_ADSB_RF_HEALTH_FAIL_TX", value: 2 },
      { name: "UAVIONIX_ADSB_RF_HEALTH_FAIL_RX", value: 16 },
    ],
  },
  {
    name: "UAVIONIX_ADSB_XBIT",
    isBitmask: true,
    entries: [
      { name: "UAVIONIX_ADSB_XBIT_ENABLED", value: 128 },
    ],
  },
  {
    name: "UTM_DATA_AVAIL_FLAGS",
    isBitmask: true,
    entries: [
      { name: "UTM_DATA_AVAIL_FLAGS_TIME_VALID", value: 1 },
      { name: "UTM_DATA_AVAIL_FLAGS_UAS_ID_AVAILABLE", value: 2 },
      { name: "UTM_DATA_AVAIL_FLAGS_POSITION_AVAILABLE", value: 4 },
      { name: "UTM_DATA_AVAIL_FLAGS_ALTITUDE_AVAILABLE", value: 8 },
      { name: "UTM_DATA_AVAIL_FLAGS_RELATIVE_ALTITUDE_AVAILABLE", value: 16 },
      { name: "UTM_DATA_AVAIL_FLAGS_HORIZONTAL_VELO_AVAILABLE", value: 32 },
      { name: "UTM_DATA_AVAIL_FLAGS_VERTICAL_VELO_AVAILABLE", value: 64 },
      { name: "UTM_DATA_AVAIL_FLAGS_NEXT_WAYPOINT_AVAILABLE", value: 128 },
    ],
  },
  {
    name: "UTM_FLIGHT_STATE",
    isBitmask: false,
    entries: [
      { name: "UTM_FLIGHT_STATE_UNKNOWN", value: 1 },
      { name: "UTM_FLIGHT_STATE_GROUND", value: 2 },
      { name: "UTM_FLIGHT_STATE_AIRBORNE", value: 3 },
      { name: "UTM_FLIGHT_STATE_EMERGENCY", value: 16 },
      { name: "UTM_FLIGHT_STATE_NOCTRL", value: 32 },
    ],
  },
  {
    name: "VIDEO_STREAM_ENCODING",
    isBitmask: false,
    entries: [
      { name: "VIDEO_STREAM_ENCODING_UNKNOWN", value: 0 },
      { name: "VIDEO_STREAM_ENCODING_H264", value: 1 },
      { name: "VIDEO_STREAM_ENCODING_H265", value: 2 },
    ],
  },
  {
    name: "VIDEO_STREAM_STATUS_FLAGS",
    isBitmask: true,
    entries: [
      { name: "VIDEO_STREAM_STATUS_FLAGS_RUNNING", value: 1 },
      { name: "VIDEO_STREAM_STATUS_FLAGS_THERMAL", value: 2 },
      { name: "VIDEO_STREAM_STATUS_FLAGS_THERMAL_RANGE_ENABLED", value: 4 },
    ],
  },
  {
    name: "VIDEO_STREAM_TYPE",
    isBitmask: false,
    entries: [
      { name: "VIDEO_STREAM_TYPE_RTSP", value: 0 },
      { name: "VIDEO_STREAM_TYPE_RTPUDP", value: 1 },
      { name: "VIDEO_STREAM_TYPE_TCP_MPEG", value: 2 },
      { name: "VIDEO_STREAM_TYPE_MPEG_TS", value: 3 },
      { name: "VIDEO_STREAM_TYPE_WHEP", value: 4 },
    ],
  },
  {
    name: "VTOL_TRANSITION_HEADING",
    isBitmask: false,
    entries: [
      { name: "VTOL_TRANSITION_HEADING_VEHICLE_DEFAULT", value: 0 },
      { name: "VTOL_TRANSITION_HEADING_NEXT_WAYPOINT", value: 1 },
      { name: "VTOL_TRANSITION_HEADING_TAKEOFF", value: 2 },
      { name: "VTOL_TRANSITION_HEADING_SPECIFIED", value: 3 },
      { name: "VTOL_TRANSITION_HEADING_ANY", value: 4 },
    ],
  },
  {
    name: "WIFI_CONFIG_AP_MODE",
    isBitmask: false,
    entries: [
      { name: "WIFI_CONFIG_AP_MODE_UNDEFINED", value: 0 },
      { name: "WIFI_CONFIG_AP_MODE_AP", value: 1 },
      { name: "WIFI_CONFIG_AP_MODE_STATION", value: 2 },
      { name: "WIFI_CONFIG_AP_MODE_DISABLED", value: 3 },
    ],
  },
  {
    name: "WIFI_CONFIG_AP_RESPONSE",
    isBitmask: false,
    entries: [
      { name: "WIFI_CONFIG_AP_RESPONSE_UNDEFINED", value: 0 },
      { name: "WIFI_CONFIG_AP_RESPONSE_ACCEPTED", value: 1 },
      { name: "WIFI_CONFIG_AP_RESPONSE_REJECTED", value: 2 },
      { name: "WIFI_CONFIG_AP_RESPONSE_MODE_ERROR", value: 3 },
      { name: "WIFI_CONFIG_AP_RESPONSE_SSID_ERROR", value: 4 },
      { name: "WIFI_CONFIG_AP_RESPONSE_PASSWORD_ERROR", value: 5 },
    ],
  },
  {
    name: "WINCH_ACTIONS",
    isBitmask: false,
    entries: [
      { name: "WINCH_RELAXED", value: 0 },
      { name: "WINCH_RELATIVE_LENGTH_CONTROL", value: 1 },
      { name: "WINCH_RATE_CONTROL", value: 2 },
      { name: "WINCH_LOCK", value: 3 },
      { name: "WINCH_DELIVER", value: 4 },
      { name: "WINCH_HOLD", value: 5 },
      { name: "WINCH_RETRACT", value: 6 },
      { name: "WINCH_LOAD_LINE", value: 7 },
      { name: "WINCH_ABANDON_LINE", value: 8 },
      { name: "WINCH_LOAD_PAYLOAD", value: 9 },
    ],
  },
];
